var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTalktoca(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 451.018,
    height: 419.49,
    viewBox: "0 0 451.018 419.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "talktoca",
    transform: "translate(-22.491 -42.851)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6292",
    "data-name": "Group 6292"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6290",
    "data-name": "Group 6290"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6289",
    "data-name": "Group 6289"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6288",
    "data-name": "Group 6288"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_361",
    "data-name": "Rectangle 361",
    width: 63.038,
    height: 63.038,
    rx: 6.371,
    transform: "translate(33.561 281.206) rotate(-12.082)",
    fill: "#ebebeb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6291",
    "data-name": "Group 6291"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5313",
    "data-name": "Path 5313",
    d: "M93.277,311.373a4.069,4.069,0,0,0-.374-1.331c-.054-.13-.107-.259-.171-.428a11.244,11.244,0,0,0-4.805-4.527,24.323,24.323,0,0,0-5.76-2.218l-.245-.062a.373.373,0,0,0-.416.175l-3.9,6.692L63.25,300.465l3.911-7.221a.374.374,0,0,0-.167-.517l-3.3-1.58c-.537-.25-.875-.407-1.1-.481a3.53,3.53,0,0,0-.316-.171c-.055-.024-.118-.056-.189-.092a5.389,5.389,0,0,0-.738-.324,10.166,10.166,0,0,0-3.928-.6,10.045,10.045,0,0,0-5.854,2.224,9.311,9.311,0,0,0-3.524,7.454,6.521,6.521,0,0,0,2.124,4.537,12.844,12.844,0,0,0,2.083,1.534l21.835,13.982c.271.168.538.341.806.515.627.4,1.275.824,1.992,1.194a12.594,12.594,0,0,0,3.267,1.143,11.749,11.749,0,0,0,2.374.243,11.309,11.309,0,0,0,4.614-.969,10.533,10.533,0,0,0,5.1-4.844,8.089,8.089,0,0,0,.684-1.629l.091-.289a4.723,4.723,0,0,0,.3-1.449l.068-.938ZM65.929,293.334l-4.1,7.223a.376.376,0,0,0,.119.5L77.737,311.42a.367.367,0,0,0,.29.052.374.374,0,0,0,.238-.174l4.074-6.89a22.692,22.692,0,0,1,4.877,1.962,9.959,9.959,0,0,1,4.164,3.852c.049.14.105.277.162.415a2.779,2.779,0,0,1,.262.939l.106.656-.07.8a3.453,3.453,0,0,1-.233,1.079l-.1.314a6.514,6.514,0,0,1-.581,1.376,9.121,9.121,0,0,1-4.391,4.174,10.058,10.058,0,0,1-6.081.63,11.136,11.136,0,0,1-2.886-1.005c-.626-.319-1.257-.725-1.866-1.117-.275-.177-.55-.354-.821-.521L52.988,304.1a11.862,11.862,0,0,1-1.906-1.366,5.223,5.223,0,0,1-1.754-3.616,8.221,8.221,0,0,1,2.986-6.5,9.075,9.075,0,0,1,5.167-2.09c.231-.013.452-.019.666-.019a9.281,9.281,0,0,1,3.822.759,2.1,2.1,0,0,0,.335.121c.2.132.514.3.994.563Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5314",
    "data-name": "Path 5314",
    d: "M72.656,295.534a27.45,27.45,0,0,0,4.4-.7c.836,4.216,1.152,4.667,1.457,4.667a.626.626,0,0,0,.12-.015h0c.351-.07.628-.138-.273-4.928,4.887-1.058,4.848-1.34,4.78-1.689h0a.419.419,0,0,0-.172-.256c-.282-.189-1.927.03-4.862.636-.567-2.845-1-4.4-1.277-4.588a.433.433,0,0,0-.3-.063.423.423,0,0,0-.255.169c-.19.28-.01,1.891.527,4.758-4.489.98-4.674,1.3-4.741,1.423a.419.419,0,0,0-.023.329C72.086,295.406,72.135,295.534,72.656,295.534Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6309",
    "data-name": "Group 6309"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6295",
    "data-name": "Group 6295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6294",
    "data-name": "Group 6294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6293",
    "data-name": "Group 6293"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_362",
    "data-name": "Rectangle 362",
    width: 109.207,
    height: 180.768,
    transform: "translate(352.362 60.073)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6298",
    "data-name": "Group 6298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6297",
    "data-name": "Group 6297"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6296",
    "data-name": "Group 6296"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_363",
    "data-name": "Rectangle 363",
    width: 109.207,
    height: 180.768,
    transform: "translate(348.73 60.073)",
    fill: "#ebebeb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6301",
    "data-name": "Group 6301"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6300",
    "data-name": "Group 6300"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6299",
    "data-name": "Group 6299"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_364",
    "data-name": "Rectangle 364",
    width: 99.906,
    height: 173.437,
    transform: "translate(353.38 63.739)",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6308",
    "data-name": "Group 6308"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6304",
    "data-name": "Group 6304"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6303",
    "data-name": "Group 6303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6302",
    "data-name": "Group 6302"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_365",
    "data-name": "Rectangle 365",
    width: 61.434,
    height: 128.363,
    transform: "translate(372.4 86.276)",
    fill: "#ebebeb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6307",
    "data-name": "Group 6307"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6306",
    "data-name": "Group 6306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6305",
    "data-name": "Group 6305"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5315",
    "data-name": "Path 5315",
    d: "M372.4,169.216c-.142-11.991,10.639-23.7,22.514-25.371,5.662-.8,11.678.325,16.968-1.844,9.444-3.872,12.448-16.419,21.952-20.141l.434,92.779H372.4Z",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6414",
    "data-name": "Group 6414"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6319",
    "data-name": "Group 6319"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6318",
    "data-name": "Group 6318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6317",
    "data-name": "Group 6317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6316",
    "data-name": "Group 6316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6315",
    "data-name": "Group 6315"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6314",
    "data-name": "Group 6314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6313",
    "data-name": "Group 6313"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6312",
    "data-name": "Group 6312"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6311",
    "data-name": "Group 6311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6310",
    "data-name": "Group 6310"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_366",
    "data-name": "Rectangle 366",
    width: 84.002,
    height: 87.565,
    transform: "translate(237.159 59.73)",
    fill: "#e0e0e0"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6338",
    "data-name": "Group 6338"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6328",
    "data-name": "Group 6328"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6327",
    "data-name": "Group 6327"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6326",
    "data-name": "Group 6326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6325",
    "data-name": "Group 6325"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6324",
    "data-name": "Group 6324"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6323",
    "data-name": "Group 6323"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6322",
    "data-name": "Group 6322"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6321",
    "data-name": "Group 6321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6320",
    "data-name": "Group 6320"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_367",
    "data-name": "Rectangle 367",
    width: 84.002,
    height: 87.565,
    transform: "translate(231.471 59.73)",
    fill: "#fafafa"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6337",
    "data-name": "Group 6337"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6336",
    "data-name": "Group 6336"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6335",
    "data-name": "Group 6335"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6334",
    "data-name": "Group 6334"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6333",
    "data-name": "Group 6333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6332",
    "data-name": "Group 6332"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6331",
    "data-name": "Group 6331"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6330",
    "data-name": "Group 6330"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6329",
    "data-name": "Group 6329"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5316",
    "data-name": "Path 5316",
    d: "M315.5,147.321H231.445V59.7H315.5Zm-84-.052h83.95V59.756H231.5Z",
    fill: "#e0e0e0"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6348",
    "data-name": "Group 6348"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6347",
    "data-name": "Group 6347"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6346",
    "data-name": "Group 6346"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6345",
    "data-name": "Group 6345"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6344",
    "data-name": "Group 6344"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6343",
    "data-name": "Group 6343"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6342",
    "data-name": "Group 6342"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6341",
    "data-name": "Group 6341"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6340",
    "data-name": "Group 6340"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6339",
    "data-name": "Group 6339"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_368",
    "data-name": "Rectangle 368",
    width: 61.418,
    height: 64.022,
    transform: "translate(242.763 71.501)",
    fill: "#fafafa"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6359",
    "data-name": "Group 6359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6358",
    "data-name": "Group 6358"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6357",
    "data-name": "Group 6357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6356",
    "data-name": "Group 6356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6355",
    "data-name": "Group 6355"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6354",
    "data-name": "Group 6354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6353",
    "data-name": "Group 6353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6352",
    "data-name": "Group 6352"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6351",
    "data-name": "Group 6351"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6350",
    "data-name": "Group 6350"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6349",
    "data-name": "Group 6349"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5317",
    "data-name": "Path 5317",
    d: "M242.763,135.95a10.077,10.077,0,0,1-1.516,1.762c-.981,1.035-2.359,2.436-3.9,3.958s-2.965,2.878-4.012,3.84a9.8,9.8,0,0,1-1.776,1.479,9.81,9.81,0,0,1,1.508-1.755c.981-1.035,2.363-2.439,3.913-3.965s2.972-2.886,4.02-3.848A9.51,9.51,0,0,1,242.763,135.95Z",
    fill: "#e0e0e0"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6370",
    "data-name": "Group 6370"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6369",
    "data-name": "Group 6369"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6368",
    "data-name": "Group 6368"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6367",
    "data-name": "Group 6367"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6366",
    "data-name": "Group 6366"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6365",
    "data-name": "Group 6365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6364",
    "data-name": "Group 6364"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6363",
    "data-name": "Group 6363"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6362",
    "data-name": "Group 6362"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6361",
    "data-name": "Group 6361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6360",
    "data-name": "Group 6360"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5318",
    "data-name": "Path 5318",
    d: "M304.18,135.793a9.922,9.922,0,0,1,1.763,1.515c1.035.981,2.436,2.359,3.958,3.9s2.878,2.966,3.84,4.013A9.836,9.836,0,0,1,315.22,147a9.664,9.664,0,0,1-1.755-1.507c-1.035-.981-2.439-2.363-3.966-3.913s-2.885-2.972-3.847-4.019A9.679,9.679,0,0,1,304.18,135.793Z",
    fill: "#e0e0e0"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6381",
    "data-name": "Group 6381"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6380",
    "data-name": "Group 6380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6379",
    "data-name": "Group 6379"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6378",
    "data-name": "Group 6378"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6377",
    "data-name": "Group 6377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6376",
    "data-name": "Group 6376"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6375",
    "data-name": "Group 6375"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6374",
    "data-name": "Group 6374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6373",
    "data-name": "Group 6373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6372",
    "data-name": "Group 6372"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6371",
    "data-name": "Group 6371"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5319",
    "data-name": "Path 5319",
    d: "M304.012,71.672a10.077,10.077,0,0,1,1.516-1.762c.981-1.035,2.359-2.436,3.9-3.958s2.966-2.878,4.013-3.841a9.793,9.793,0,0,1,1.775-1.478,9.892,9.892,0,0,1-1.508,1.755c-.981,1.035-2.363,2.439-3.913,3.965s-2.972,2.885-4.02,3.848A9.509,9.509,0,0,1,304.012,71.672Z",
    fill: "#e0e0e0"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6392",
    "data-name": "Group 6392"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6391",
    "data-name": "Group 6391"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6390",
    "data-name": "Group 6390"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6389",
    "data-name": "Group 6389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6388",
    "data-name": "Group 6388"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6387",
    "data-name": "Group 6387"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6386",
    "data-name": "Group 6386"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6385",
    "data-name": "Group 6385"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6384",
    "data-name": "Group 6384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6383",
    "data-name": "Group 6383"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6382",
    "data-name": "Group 6382"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5320",
    "data-name": "Path 5320",
    d: "M242.6,71.829a10,10,0,0,1-1.762-1.515c-1.036-.981-2.436-2.36-3.958-3.905S234,63.444,233.034,62.4a9.687,9.687,0,0,1-1.478-1.775,9.777,9.777,0,0,1,1.754,1.507c1.035.981,2.44,2.363,3.966,3.913s2.885,2.973,3.847,4.02A9.68,9.68,0,0,1,242.6,71.829Z",
    fill: "#e0e0e0"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6403",
    "data-name": "Group 6403"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6402",
    "data-name": "Group 6402"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6401",
    "data-name": "Group 6401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6400",
    "data-name": "Group 6400"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6399",
    "data-name": "Group 6399"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6398",
    "data-name": "Group 6398"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6397",
    "data-name": "Group 6397"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6396",
    "data-name": "Group 6396"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6395",
    "data-name": "Group 6395"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6394",
    "data-name": "Group 6394"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6393",
    "data-name": "Group 6393"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5321",
    "data-name": "Path 5321",
    d: "M304.012,135.524s-.008-.109-.013-.311c0-.219-.008-.513-.013-.894-.007-.8-.016-1.957-.028-3.456-.014-3.033-.036-7.445-.062-13.048-.029-11.213-.071-27.187-.12-46.314l.236.237-61.243.035h-.006l.272-.272c-.014,23.5-.028,45.483-.038,64.023l-.234-.233,44.349.119,12.457.061,3.3.027.852.013a2.748,2.748,0,0,1,.3.013,1.947,1.947,0,0,1-.27.013l-.827.013-3.251.027-12.4.061-44.5.12h-.233v-.234c-.011-18.54-.024-40.524-.038-64.023v-.272h.278l61.243.035h.238V71.5c-.05,19.19-.092,35.216-.121,46.466-.027,5.58-.048,9.974-.062,12.994-.012,1.48-.021,2.619-.028,3.411-.005.37-.01.655-.013.868A2.032,2.032,0,0,1,304.012,135.524Z",
    fill: "#e0e0e0"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6413",
    "data-name": "Group 6413"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6412",
    "data-name": "Group 6412"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6411",
    "data-name": "Group 6411"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6410",
    "data-name": "Group 6410"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6409",
    "data-name": "Group 6409"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6408",
    "data-name": "Group 6408"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6407",
    "data-name": "Group 6407"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6406",
    "data-name": "Group 6406"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6405",
    "data-name": "Group 6405"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6404",
    "data-name": "Group 6404"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_369",
    "data-name": "Rectangle 369",
    width: 20.494,
    height: 20.494,
    transform: "translate(263.224 93.266)",
    fill: "#ebebeb"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6439",
    "data-name": "Group 6439"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6431",
    "data-name": "Group 6431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6418",
    "data-name": "Group 6418"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6417",
    "data-name": "Group 6417"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6416",
    "data-name": "Group 6416"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6415",
    "data-name": "Group 6415"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5322",
    "data-name": "Path 5322",
    d: "M459.7,428.45l-3.248,33.294H439.259l-3.383-33.294Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6422",
    "data-name": "Group 6422"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6421",
    "data-name": "Group 6421"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6420",
    "data-name": "Group 6420"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6419",
    "data-name": "Group 6419"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_370",
    "data-name": "Rectangle 370",
    width: 28.421,
    height: 2.436,
    transform: "translate(462.267 428.45) rotate(180)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6426",
    "data-name": "Group 6426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6425",
    "data-name": "Group 6425"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6424",
    "data-name": "Group 6424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6423",
    "data-name": "Group 6423"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5323",
    "data-name": "Path 5323",
    d: "M456.853,421.819l2.842,4.737h-22.6l1.083-4.737Z",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6430",
    "data-name": "Group 6430"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6429",
    "data-name": "Group 6429"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6428",
    "data-name": "Group 6428"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6427",
    "data-name": "Group 6427"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5324",
    "data-name": "Path 5324",
    d: "M458.6,439.659l-1.159,11.881H438.222l-1.207-11.881Z",
    fill: "#f5f5f5"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6438",
    "data-name": "Group 6438"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6434",
    "data-name": "Group 6434"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6433",
    "data-name": "Group 6433"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6432",
    "data-name": "Group 6432"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5325",
    "data-name": "Path 5325",
    d: "M445.339,448.943a5.452,5.452,0,0,1,.89-2.939c.481-.745,1.061-1.389,1.528-2.031a6.153,6.153,0,0,0,.993-1.876,3.468,3.468,0,0,0,.152-.824c.044.023.09.042.132.069a3.01,3.01,0,0,1,1.256,1.964,5.669,5.669,0,0,1-.109,2.374,5.122,5.122,0,0,1-1.25,2.521,3.445,3.445,0,0,1-3,.929A2.771,2.771,0,0,1,445.339,448.943Z",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6437",
    "data-name": "Group 6437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6436",
    "data-name": "Group 6436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6435",
    "data-name": "Group 6435"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5326",
    "data-name": "Path 5326",
    d: "M443.885,446.328a9.915,9.915,0,0,1,.607-3.114,3.441,3.441,0,0,1,2.274-2.108,2.667,2.667,0,0,1,1.652.078,3.6,3.6,0,0,1-.2.836,6.409,6.409,0,0,1-1.015,1.76c-.47.618-1.06,1.256-1.565,2.036a5.519,5.519,0,0,0-.873,2.456c-.019.18-.026.354-.028.525a1.789,1.789,0,0,1-.651-.659A3.161,3.161,0,0,1,443.885,446.328Z",
    fill: "#fafafa"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6487",
    "data-name": "Group 6487"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6446",
    "data-name": "Group 6446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6445",
    "data-name": "Group 6445"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6444",
    "data-name": "Group 6444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6443",
    "data-name": "Group 6443"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6442",
    "data-name": "Group 6442"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6441",
    "data-name": "Group 6441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6440",
    "data-name": "Group 6440"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5327",
    "data-name": "Path 5327",
    d: "M304.734,410.43c15.511-15.532,15.438-39.221,11.059-59.747-.731-3.426-1-7.127-3.178-9.86s-6.373-4.117-9.2-2.115c-2.346,1.661-2.931,4.837-3.924,7.555a20.487,20.487,0,0,1-6.709,9.162c-1.992,1.529-4.584,2.71-6.964,1.9-3.265-1.111-4.348-5.156-4.937-8.589q-1.647-9.6-3.3-19.191c-.589-3.431-1.2-6.934-2.848-10s-4.541-5.667-7.964-6-7.123,2.267-7.214,5.745a32.18,32.18,0,0,0,.663,4.286c.158,1.441-.224,3.133-1.505,3.771-1.3.646-2.842-.082-4.046-.9-4.155-2.831-7.35-6.863-10.384-10.9s-6.021-8.187-9.9-11.391-8.857-5.4-13.816-4.808-9.652,4.559-10.034,9.6,3.31,9.457,7.076,12.823a77.73,77.73,0,0,0,18.639,12.35,6.392,6.392,0,0,1,3.175,2.391c1.152,2.153-.609,4.809-2.732,5.962-2.4,1.306-5.224,1.535-7.841,2.326s-5.3,2.485-5.864,5.192c-.781,3.754,2.8,6.9,6.116,8.8a66.582,66.582,0,0,0,21.4,7.744c2.687.474,5.485.811,7.834,2.22s4.126,4.273,3.327,6.906-3.815,3.971-6.544,3.952-5.348-1.033-8.035-1.534c-5.028-.939-11.054.469-13.347,5.079-1.507,3.03-1.017,6.788.554,9.8a25.41,25.41,0,0,0,6.707,7.547,66.959,66.959,0,0,0,31.672,14.768c11.6,1.842,21.913,1.064,32.067-4.843",
    fill: "#f5f5f5"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6454",
    "data-name": "Group 6454"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6453",
    "data-name": "Group 6453"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6452",
    "data-name": "Group 6452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6451",
    "data-name": "Group 6451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6450",
    "data-name": "Group 6450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6449",
    "data-name": "Group 6449"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6448",
    "data-name": "Group 6448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6447",
    "data-name": "Group 6447"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5328",
    "data-name": "Path 5328",
    d: "M297.1,398.434a312.08,312.08,0,0,0-18.086-30.9l-5.157-7.857c-1.7-2.574-3.382-5.128-5.184-7.524a155.727,155.727,0,0,0-11.142-13.173c-3.746-4.019-7.448-7.7-10.934-11.109s-6.812-6.52-9.957-9.229a123.625,123.625,0,0,0-15.775-11.668c-1.964-1.227-3.518-2.129-4.58-2.726l-1.211-.672a2.774,2.774,0,0,0-.423-.209,2.313,2.313,0,0,0,.39.267l1.18.727c1.039.633,2.572,1.569,4.513,2.826a130.828,130.828,0,0,1,15.612,11.8c3.117,2.723,6.409,5.848,9.882,9.267s7.15,7.113,10.876,11.132a157.5,157.5,0,0,1,11.068,13.146c1.789,2.385,3.455,4.918,5.156,7.5l5.152,7.854A319.873,319.873,0,0,1,296.572,398.7",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6462",
    "data-name": "Group 6462"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6461",
    "data-name": "Group 6461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6460",
    "data-name": "Group 6460"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6459",
    "data-name": "Group 6459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6458",
    "data-name": "Group 6458"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6457",
    "data-name": "Group 6457"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6456",
    "data-name": "Group 6456"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6455",
    "data-name": "Group 6455"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5329",
    "data-name": "Path 5329",
    d: "M268.486,352.159a7.028,7.028,0,0,0,.075-1.522c.011-.98-.019-2.4-.083-4.148-.123-3.5-.458-8.327-.848-13.647s-.656-10.143-.725-13.634c-.04-1.746-.058-3.16-.058-4.137a7,7,0,0,0-.073-1.523,6.862,6.862,0,0,0-.176,1.514c-.076.977-.128,2.394-.145,4.146-.047,3.505.148,8.348.539,13.677.4,5.249.758,10,1.034,13.627.114,1.64.209,3.022.285,4.132A6.966,6.966,0,0,0,268.486,352.159Z",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6470",
    "data-name": "Group 6470"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6469",
    "data-name": "Group 6469"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6468",
    "data-name": "Group 6468"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6467",
    "data-name": "Group 6467"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6466",
    "data-name": "Group 6466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6465",
    "data-name": "Group 6465"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6464",
    "data-name": "Group 6464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6463",
    "data-name": "Group 6463"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5330",
    "data-name": "Path 5330",
    d: "M222.941,351.772a9.682,9.682,0,0,0,1.795-.1c1.149-.1,2.811-.256,4.87-.381,4.114-.284,9.812-.476,16.108-.413s11.993.384,16.106.727c2.059.156,3.721.328,4.871.44a9.683,9.683,0,0,0,1.795.116,9.6,9.6,0,0,0-1.765-.367c-1.142-.188-2.8-.429-4.861-.646-4.114-.461-9.827-.844-16.143-.919a157.948,157.948,0,0,0-16.149.605c-2.061.184-3.72.408-4.863.588A9.517,9.517,0,0,0,222.941,351.772Z",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6478",
    "data-name": "Group 6478"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6477",
    "data-name": "Group 6477"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6476",
    "data-name": "Group 6476"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6475",
    "data-name": "Group 6475"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6474",
    "data-name": "Group 6474"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6473",
    "data-name": "Group 6473"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6472",
    "data-name": "Group 6472"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6471",
    "data-name": "Group 6471"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5331",
    "data-name": "Path 5331",
    d: "M296.411,397.72a2.292,2.292,0,0,0,.207-.591l.47-1.729c.4-1.5.925-3.694,1.536-6.408,1.227-5.428,2.687-12.98,4.184-21.335s2.886-15.913,4-21.359c.548-2.649,1-4.828,1.336-6.447.142-.7.258-1.281.354-1.757a2.314,2.314,0,0,0,.08-.623,2.391,2.391,0,0,0-.206.592c-.127.468-.282,1.037-.47,1.728-.4,1.5-.925,3.693-1.537,6.408-1.227,5.428-2.686,12.98-4.184,21.338s-2.885,15.91-4,21.357c-.55,2.648-1,4.827-1.336,6.446-.142.7-.258,1.282-.354,1.757A2.356,2.356,0,0,0,296.411,397.72Z",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6486",
    "data-name": "Group 6486"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6485",
    "data-name": "Group 6485"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6484",
    "data-name": "Group 6484"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6483",
    "data-name": "Group 6483"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6482",
    "data-name": "Group 6482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6481",
    "data-name": "Group 6481"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6480",
    "data-name": "Group 6480"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6479",
    "data-name": "Group 6479"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5332",
    "data-name": "Path 5332",
    d: "M234.476,389.275a2.327,2.327,0,0,0,.624.136l1.8.268,6.635.915c5.6.774,13.326,1.932,21.86,3.223s16.28,2.381,21.9,3.039c2.81.33,5.086.574,6.662.711l1.816.146a2.333,2.333,0,0,0,.637.007,2.451,2.451,0,0,0-.624-.137l-1.8-.266-6.634-.916c-5.6-.773-13.327-1.932-21.863-3.224s-16.277-2.38-21.9-3.038c-2.81-.33-5.085-.574-6.663-.71l-1.816-.147A2.338,2.338,0,0,0,234.476,389.275Z",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6591",
    "data-name": "Group 6591"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6555",
    "data-name": "Group 6555"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6494",
    "data-name": "Group 6494"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6493",
    "data-name": "Group 6493"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6492",
    "data-name": "Group 6492"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6491",
    "data-name": "Group 6491"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6490",
    "data-name": "Group 6490"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6489",
    "data-name": "Group 6489"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6488",
    "data-name": "Group 6488"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_371",
    "data-name": "Rectangle 371",
    width: 70.86,
    height: 73.866,
    transform: "translate(45.388 42.884) rotate(0.131)",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6507",
    "data-name": "Group 6507"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6500",
    "data-name": "Group 6500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6499",
    "data-name": "Group 6499"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6498",
    "data-name": "Group 6498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6497",
    "data-name": "Group 6497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6496",
    "data-name": "Group 6496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6495",
    "data-name": "Group 6495"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_372",
    "data-name": "Rectangle 372",
    width: 70.86,
    height: 73.866,
    transform: "translate(40.589 42.873) rotate(0.131)",
    fill: "#455a64"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6506",
    "data-name": "Group 6506"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6505",
    "data-name": "Group 6505"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6504",
    "data-name": "Group 6504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6503",
    "data-name": "Group 6503"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6502",
    "data-name": "Group 6502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6501",
    "data-name": "Group 6501"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5333",
    "data-name": "Path 5333",
    d: "M111.3,116.923l-70.9-.162.169-73.91,70.9.163Z",
    fill: "#f5f5f5"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6514",
    "data-name": "Group 6514"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6513",
    "data-name": "Group 6513"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6512",
    "data-name": "Group 6512"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6511",
    "data-name": "Group 6511"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6510",
    "data-name": "Group 6510"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6509",
    "data-name": "Group 6509"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6508",
    "data-name": "Group 6508"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_373",
    "data-name": "Rectangle 373",
    width: 51.809,
    height: 54.007,
    transform: "translate(50.092 52.824) rotate(0.131)",
    fill: "#fff"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6522",
    "data-name": "Group 6522"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6521",
    "data-name": "Group 6521"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6520",
    "data-name": "Group 6520"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6519",
    "data-name": "Group 6519"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6518",
    "data-name": "Group 6518"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6517",
    "data-name": "Group 6517"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6516",
    "data-name": "Group 6516"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6515",
    "data-name": "Group 6515"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5334",
    "data-name": "Path 5334",
    d: "M49.967,107.19a8.42,8.42,0,0,1-1.282,1.484c-.829.871-2,2.05-3.3,3.331s-2.507,2.422-3.392,3.232a8.235,8.235,0,0,1-1.5,1.243A8.194,8.194,0,0,1,41.767,115c.829-.871,2-2.053,3.308-3.338s2.513-2.428,3.4-3.237A8.073,8.073,0,0,1,49.967,107.19Z",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6530",
    "data-name": "Group 6530"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6529",
    "data-name": "Group 6529"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6528",
    "data-name": "Group 6528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6527",
    "data-name": "Group 6527"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6526",
    "data-name": "Group 6526"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6525",
    "data-name": "Group 6525"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6524",
    "data-name": "Group 6524"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6523",
    "data-name": "Group 6523"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5335",
    "data-name": "Path 5335",
    d: "M101.776,107.176a8.432,8.432,0,0,1,1.484,1.282c.871.829,2.05,2,3.331,3.3s2.422,2.507,3.232,3.392a8.273,8.273,0,0,1,1.244,1.5,8.177,8.177,0,0,1-1.478-1.275c-.871-.829-2.053-2-3.337-3.308s-2.428-2.513-3.238-3.4A8.127,8.127,0,0,1,101.776,107.176Z",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6538",
    "data-name": "Group 6538"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6537",
    "data-name": "Group 6537"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6536",
    "data-name": "Group 6536"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6535",
    "data-name": "Group 6535"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6534",
    "data-name": "Group 6534"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6533",
    "data-name": "Group 6533"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6532",
    "data-name": "Group 6532"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6531",
    "data-name": "Group 6531"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5336",
    "data-name": "Path 5336",
    d: "M101.759,53.087A8.455,8.455,0,0,1,103.04,51.6c.83-.872,2-2.051,3.3-3.331s2.507-2.423,3.392-3.232a8.255,8.255,0,0,1,1.5-1.244,8.3,8.3,0,0,1-1.275,1.477c-.83.871-2,2.053-3.309,3.338s-2.513,2.428-3.4,3.238A8.075,8.075,0,0,1,101.759,53.087Z",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6546",
    "data-name": "Group 6546"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6545",
    "data-name": "Group 6545"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6544",
    "data-name": "Group 6544"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6543",
    "data-name": "Group 6543"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6542",
    "data-name": "Group 6542"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6541",
    "data-name": "Group 6541"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6540",
    "data-name": "Group 6540"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6539",
    "data-name": "Group 6539"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5337",
    "data-name": "Path 5337",
    d: "M49.949,53.1a8.495,8.495,0,0,1-1.483-1.282c-.872-.829-2.05-1.995-3.331-3.3s-2.423-2.507-3.232-3.392a8.273,8.273,0,0,1-1.244-1.5A8.2,8.2,0,0,1,42.136,44.9c.871.829,2.053,2,3.338,3.308s2.428,2.513,3.238,3.4A8.036,8.036,0,0,1,49.949,53.1Z",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6554",
    "data-name": "Group 6554"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6553",
    "data-name": "Group 6553"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6552",
    "data-name": "Group 6552"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6551",
    "data-name": "Group 6551"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6550",
    "data-name": "Group 6550"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6549",
    "data-name": "Group 6549"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6548",
    "data-name": "Group 6548"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6547",
    "data-name": "Group 6547"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5338",
    "data-name": "Path 5338",
    d: "M101.635,106.95a2.585,2.585,0,0,1-.011-.263c0-.184,0-.432-.009-.754,0-.677-.01-1.651-.017-2.915-.006-2.559-.015-6.281-.027-11.007,0-9.459-.007-22.934-.012-39.068l.2.2L50.1,53.054h-.005l.23-.229c-.057,19.823-.111,38.367-.156,54.006l-.2-.2,37.41.186,10.509.076,2.78.029.718.013a2.144,2.144,0,0,1,.25.012,1.813,1.813,0,0,1-.228.01l-.7.009-2.743.017-10.464.027-37.536.015h-.2v-.2c.026-15.639.058-34.183.091-54.006V52.6H50.1l51.662.148h.2v.2c-.079,16.187-.145,29.705-.192,39.195-.033,4.707-.059,8.414-.077,10.962-.013,1.247-.023,2.208-.03,2.876-.006.313-.01.554-.013.732A1.731,1.731,0,0,1,101.635,106.95Z",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6583",
    "data-name": "Group 6583"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6561",
    "data-name": "Group 6561"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6560",
    "data-name": "Group 6560"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6559",
    "data-name": "Group 6559"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6558",
    "data-name": "Group 6558"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6557",
    "data-name": "Group 6557"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6556",
    "data-name": "Group 6556"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5339",
    "data-name": "Path 5339",
    d: "M66.349,94.5a11.462,11.462,0,0,1-.475-15.076c1.444-1.65,3.361-2.852,4.7-4.588,2.9-3.76,2.869-9.692,6.9-12.206,2.936-1.834,7.144-.773,9.279,1.953a9.83,9.83,0,0,1,.906,9.848C86.622,76.77,84.834,78.757,84.1,81.2c-.754,2.5-.333,5.248-1.116,7.742-.946,3.011-4.139,4.909-7.1,6a13.285,13.285,0,0,1-9.529-.444",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6568",
    "data-name": "Group 6568"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6567",
    "data-name": "Group 6567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6566",
    "data-name": "Group 6566"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6565",
    "data-name": "Group 6565"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6564",
    "data-name": "Group 6564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6563",
    "data-name": "Group 6563"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6562",
    "data-name": "Group 6562"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5340",
    "data-name": "Path 5340",
    d: "M80.978,69.655a9.242,9.242,0,0,1-.5,1.426c-.348.909-.9,2.207-1.615,3.793a106.121,106.121,0,0,1-6.431,11.982,106.047,106.047,0,0,1-7.92,11.057c-1.106,1.344-2.028,2.409-2.691,3.122a9.438,9.438,0,0,1-1.057,1.082,9.419,9.419,0,0,1,.92-1.2c.619-.748,1.5-1.843,2.571-3.21a128.439,128.439,0,0,0,7.781-11.1A128.54,128.54,0,0,0,78.56,74.734c.754-1.563,1.348-2.838,1.747-3.724A9.342,9.342,0,0,1,80.978,69.655Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6575",
    "data-name": "Group 6575"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6574",
    "data-name": "Group 6574"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6573",
    "data-name": "Group 6573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6572",
    "data-name": "Group 6572"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6571",
    "data-name": "Group 6571"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6570",
    "data-name": "Group 6570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6569",
    "data-name": "Group 6569"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5341",
    "data-name": "Path 5341",
    d: "M70.239,78.99a17.3,17.3,0,0,1,.41,2.732c.2,1.705.449,4.082.7,6.766l-.346-.178,1.118-.651c2.593-1.5,4.953-2.845,6.673-3.795a21.416,21.416,0,0,1,2.833-1.453,21.518,21.518,0,0,1-2.667,1.738c-1.678,1.023-4.012,2.408-6.606,3.913l-1.119.648-.314.181-.033-.36c-.242-2.685-.435-5.068-.553-6.78A17.458,17.458,0,0,1,70.239,78.99Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6582",
    "data-name": "Group 6582"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6581",
    "data-name": "Group 6581"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6580",
    "data-name": "Group 6580"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6579",
    "data-name": "Group 6579"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6578",
    "data-name": "Group 6578"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6577",
    "data-name": "Group 6577"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6576",
    "data-name": "Group 6576"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5342",
    "data-name": "Path 5342",
    d: "M83.857,75.024A8.5,8.5,0,0,1,82.109,76c-1.105.548-2.644,1.275-4.356,2.053l-.534.241-.278.126-.047-.3c-.266-1.726-.481-3.267-.614-4.38a7.375,7.375,0,0,1-.124-1.805,7.4,7.4,0,0,1,.436,1.756c.215,1.1.484,2.633.761,4.357l-.325-.175.533-.243c1.712-.778,3.272-1.458,4.412-1.929A8.645,8.645,0,0,1,83.857,75.024Z",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6590",
    "data-name": "Group 6590"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6589",
    "data-name": "Group 6589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6588",
    "data-name": "Group 6588"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6587",
    "data-name": "Group 6587"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6586",
    "data-name": "Group 6586"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6585",
    "data-name": "Group 6585"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6584",
    "data-name": "Group 6584"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5343",
    "data-name": "Path 5343",
    d: "M48.184,43.921",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6594",
    "data-name": "Group 6594"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6593",
    "data-name": "Group 6593"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6592",
    "data-name": "Group 6592"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5344",
    "data-name": "Path 5344",
    d: "M473.509,461.744c0,.144-100.972.26-225.5.26-124.57,0-225.52-.116-225.52-.26s100.95-.261,225.52-.261C372.537,461.483,473.509,461.6,473.509,461.744Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6667",
    "data-name": "Group 6667"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6628",
    "data-name": "Group 6628"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6599",
    "data-name": "Group 6599"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6598",
    "data-name": "Group 6598"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6597",
    "data-name": "Group 6597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6596",
    "data-name": "Group 6596"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6595",
    "data-name": "Group 6595"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5345",
    "data-name": "Path 5345",
    d: "M145.126,373.251c4.71-2.43,10.257-2.746,15.486-1.881,2.809.464,5.738,1.3,7.65,3.414s2.274,5.824.079,7.638a7.329,7.329,0,0,1-4.824,1.223c-4.093-.047-8.636-.768-11.906,1.7-1.866,1.4-3.108,3.741-5.339,4.432a5.272,5.272,0,0,1-5.8-2.581,9.013,9.013,0,0,1-.657-6.652A10.156,10.156,0,0,1,145.126,373.251Z",
    fill: "#ff725e"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6604",
    "data-name": "Group 6604"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6603",
    "data-name": "Group 6603"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6602",
    "data-name": "Group 6602"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6601",
    "data-name": "Group 6601"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6600",
    "data-name": "Group 6600"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5346",
    "data-name": "Path 5346",
    d: "M134.335,352.419c2.88,4.114,8.478,2.752,11.073.241s3.693-6.15,4.691-9.621c2.282-7.929,4.583-16.247,2.886-24.321a13.515,13.515,0,0,0-3.106-6.613,7.06,7.06,0,0,0-6.69-2.226c-2.822.745-4.577,3.51-5.844,6.14a57.972,57.972,0,0,0-5.73,24.881c-.014,4.007.459,8.21,2.72,11.519",
    fill: "#ff725e"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6609",
    "data-name": "Group 6609"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6608",
    "data-name": "Group 6608"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6607",
    "data-name": "Group 6607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6606",
    "data-name": "Group 6606"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6605",
    "data-name": "Group 6605"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5347",
    "data-name": "Path 5347",
    d: "M126.425,358.322c3.127-3.712,3.721-9.125,2.329-13.775s-4.535-8.605-8.158-11.834a43.916,43.916,0,0,0-14.609-8.62,15.57,15.57,0,0,0-6.57-1.116,6.893,6.893,0,0,0-5.514,3.336c-1.538,2.932-.064,6.489,1.531,9.39a111.258,111.258,0,0,0,9.6,14.612c2.876,3.708,6.171,7.366,10.554,9.041s8.936,1.479,11.26-1.561",
    fill: "#ff725e"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6615",
    "data-name": "Group 6615"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6614",
    "data-name": "Group 6614"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6613",
    "data-name": "Group 6613"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6612",
    "data-name": "Group 6612"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6611",
    "data-name": "Group 6611"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6610",
    "data-name": "Group 6610"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5348",
    "data-name": "Path 5348",
    d: "M134.14,414.473a9.06,9.06,0,0,0,.26-1.869c.132-1.361.3-3.069.5-5.1a73.554,73.554,0,0,1,1.147-7.482,57.779,57.779,0,0,1,2.72-8.831,32.509,32.509,0,0,1,4.51-7.991,16.83,16.83,0,0,1,5.7-4.74,15.955,15.955,0,0,1,4.8-1.495,8.979,8.979,0,0,0,1.861-.27,8.762,8.762,0,0,0-1.894-.029,14.553,14.553,0,0,0-5.006,1.3,16.8,16.8,0,0,0-6.014,4.781,31.78,31.78,0,0,0-4.675,8.152,53.952,53.952,0,0,0-2.7,8.975,63.394,63.394,0,0,0-1,7.578c-.162,2.166-.223,3.92-.253,5.132A8.7,8.7,0,0,0,134.14,414.473Z",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6621",
    "data-name": "Group 6621"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6620",
    "data-name": "Group 6620"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6619",
    "data-name": "Group 6619"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6618",
    "data-name": "Group 6618"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6617",
    "data-name": "Group 6617"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6616",
    "data-name": "Group 6616"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5349",
    "data-name": "Path 5349",
    d: "M134.491,410.548a3.678,3.678,0,0,0,.05-.868c0-.651,0-1.472-.006-2.48-.006-2.153-.005-5.268.11-9.114.191-7.693.853-15.972,2.132-27.645,1.212-10.976,2.838-23.749,4.554-32.054.368-1.889.739-3.589,1.088-5.077.332-1.492.616-2.778.89-3.818.236-.98.428-1.778.58-2.411a3.77,3.77,0,0,0,.152-.856,3.643,3.643,0,0,0-.3.813c-.189.625-.427,1.411-.72,2.377-.319,1.031-.647,2.309-1.02,3.795-.39,1.482-.8,3.177-1.2,5.063a281.825,281.825,0,0,0-4.787,29.743c-1.282,11.7-1.859,22.347-1.91,30.06-.046,3.856.036,6.977.134,9.131.062,1.008.112,1.828.152,2.479A3.653,3.653,0,0,0,134.491,410.548Z",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6627",
    "data-name": "Group 6627"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6626",
    "data-name": "Group 6626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6625",
    "data-name": "Group 6625"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6624",
    "data-name": "Group 6624"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6623",
    "data-name": "Group 6623"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6622",
    "data-name": "Group 6622"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5350",
    "data-name": "Path 5350",
    d: "M134.543,390.006a16.571,16.571,0,0,0-.019-2.591c-.1-1.665-.324-4.071-.793-7.019a92.622,92.622,0,0,0-2.283-10.228,83.747,83.747,0,0,0-4.277-12.1,64.469,64.469,0,0,0-12.559-19.557,31.891,31.891,0,0,0-2.955-2.746c-.453-.384-.854-.766-1.262-1.069l-1.146-.79a16.575,16.575,0,0,0-2.182-1.4c-.123.169,3.091,2.061,7.15,6.379a67.913,67.913,0,0,1,12.246,19.486,95.607,95.607,0,0,1,4.3,11.99,103.744,103.744,0,0,1,2.429,10.126c.535,2.918.845,5.3,1.032,6.951A16.658,16.658,0,0,0,134.543,390.006Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6633",
    "data-name": "Group 6633"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6632",
    "data-name": "Group 6632"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6631",
    "data-name": "Group 6631"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6630",
    "data-name": "Group 6630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6629",
    "data-name": "Group 6629"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5351",
    "data-name": "Path 5351",
    d: "M114.688,426.241l2.058,28.2h36.227l2.058-28.2Z",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6638",
    "data-name": "Group 6638"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6637",
    "data-name": "Group 6637"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6636",
    "data-name": "Group 6636"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6635",
    "data-name": "Group 6635"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6634",
    "data-name": "Group 6634"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_374",
    "data-name": "Rectangle 374",
    width: 48.165,
    height: 11.115,
    transform: "translate(111.189 415.126)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6643",
    "data-name": "Group 6643"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6642",
    "data-name": "Group 6642"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6641",
    "data-name": "Group 6641"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6640",
    "data-name": "Group 6640"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6639",
    "data-name": "Group 6639"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5352",
    "data-name": "Path 5352",
    d: "M111.189,453.362v3.081h47.369v-3.081Z",
    fill: "#455a64"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6648",
    "data-name": "Group 6648"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6647",
    "data-name": "Group 6647"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6646",
    "data-name": "Group 6646"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6645",
    "data-name": "Group 6645"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6644",
    "data-name": "Group 6644"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5353",
    "data-name": "Path 5353",
    d: "M115.671,461.865l-2.218-5.423h43.381l-2.588,5.423Z",
    fill: "#455a64"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6654",
    "data-name": "Group 6654"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6653",
    "data-name": "Group 6653"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6652",
    "data-name": "Group 6652"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6651",
    "data-name": "Group 6651"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6650",
    "data-name": "Group 6650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6649",
    "data-name": "Group 6649"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5354",
    "data-name": "Path 5354",
    d: "M154.359,435.458a1.248,1.248,0,0,1-.169.259c-.144.19-.322.427-.541.718l-2.111,2.7-.094.12-.09-.125-5.185-7.171h.3l-5.1,7.228-.16.226-.18-.213L134.97,432l.349,0-.333.419c-1.878,2.353-3.695,4.631-5.413,6.786l-.181.226-.166-.235-5.108-7.227.3.015-6.289,7.166-.112.127-.085-.143c-.829-1.393-1.49-2.5-1.97-3.309-.205-.359-.372-.649-.5-.881a1.368,1.368,0,0,1-.154-.314,1.385,1.385,0,0,1,.211.279l.559.848L118.137,439l-.2-.016,6.188-7.253.156-.183.142.2,5.152,7.193-.346-.009,5.4-6.8.333-.419.172-.216.177.212,6.037,7.217-.339.013,5.156-7.191.151-.211.147.211,5.075,7.248-.184-.005,2.195-2.632.588-.681C154.277,435.526,154.351,435.451,154.359,435.458Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6660",
    "data-name": "Group 6660"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6659",
    "data-name": "Group 6659"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6658",
    "data-name": "Group 6658"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6657",
    "data-name": "Group 6657"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6656",
    "data-name": "Group 6656"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6655",
    "data-name": "Group 6655"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5355",
    "data-name": "Path 5355",
    d: "M155.536,426.055c0,.125-9.078.226-20.272.226s-20.274-.1-20.274-.226,9.075-.225,20.274-.225S155.536,425.931,155.536,426.055Z",
    fill: "#455a64"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6666",
    "data-name": "Group 6666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6665",
    "data-name": "Group 6665"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6664",
    "data-name": "Group 6664"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6663",
    "data-name": "Group 6663"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6662",
    "data-name": "Group 6662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6661",
    "data-name": "Group 6661"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5356",
    "data-name": "Path 5356",
    d: "M157.366,456.746c0,.125-9.865.226-22.032.226s-22.034-.1-22.034-.226,9.863-.225,22.034-.225S157.366,456.622,157.366,456.746Z",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Character_2",
    "data-name": "Character 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7105",
    "data-name": "Group 7105"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6681",
    "data-name": "Group 6681"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6672",
    "data-name": "Group 6672"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6671",
    "data-name": "Group 6671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6670",
    "data-name": "Group 6670"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6669",
    "data-name": "Group 6669"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6668",
    "data-name": "Group 6668"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5357",
    "data-name": "Path 5357",
    d: "M424.685,241.887c-.785-3.391,3.217-15.1.634-15.364-3.291-.332-3.848,12.987-3.965,14.182-.114,1.16-1.844,1.021-1.68-.05.234-1.54,2.427-16.611-.9-16.647-1.842-.02-1.919,3.331-1.919,3.331s-1.24,14.852-2.809,14.782c-1.593-.071-.446-8.522-.286-11.665.153-3.014-1.357-4.745-2.473-3.442-1.636,1.909-1.626,9.563-1.827,12.579s-1.013,11.679-4.124,7.345-7.1-6.525-8.569-6.375-1.745,2.268-.318,3.1a19.908,19.908,0,0,1,3.891,3.712,19.009,19.009,0,0,1,2.241,3.683,16.619,16.619,0,0,1,1.632,5.251,10.334,10.334,0,0,0,4.58,7.131l-.175,23.794L407.884,299l18.524,6.427-2.434-41.981c.909-8.068,4.461-18.272,5.758-23,2.067-7.542,1.1-7.87.177-7.911C427.871,232.446,425.451,245.2,424.685,241.887Z",
    fill: "#a36957"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6676",
    "data-name": "Group 6676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6675",
    "data-name": "Group 6675"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6674",
    "data-name": "Group 6674"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6673",
    "data-name": "Group 6673"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5358",
    "data-name": "Path 5358",
    d: "M422.312,252.122a17.158,17.158,0,0,0-2.272.381,8.618,8.618,0,0,0-5.428,4.557l-.121.244-.18-.186a13.024,13.024,0,0,0-3.512-2.567c-.978-.489-1.611-.685-1.6-.739a5.246,5.246,0,0,1,1.7.514,11.691,11.691,0,0,1,3.675,2.518l-.3.058a8.672,8.672,0,0,1,.933-1.544,8.836,8.836,0,0,1,2.381-2.139,8.4,8.4,0,0,1,2.388-.984,7.09,7.09,0,0,1,1.711-.193A1.828,1.828,0,0,1,422.312,252.122Z",
    fill: "#7c3b29"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6680",
    "data-name": "Group 6680"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6679",
    "data-name": "Group 6679"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6678",
    "data-name": "Group 6678"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6677",
    "data-name": "Group 6677"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5359",
    "data-name": "Path 5359",
    d: "M421.4,263.267a13.823,13.823,0,0,1-8.048.26c.019-.113,1.811.168,4.031.089C419.6,263.552,421.372,263.155,421.4,263.267Z",
    fill: "#7c3b29"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6782",
    "data-name": "Group 6782"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6683",
    "data-name": "Group 6683"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6682",
    "data-name": "Group 6682"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5360",
    "data-name": "Path 5360",
    d: "M309.413,201.2a13.922,13.922,0,0,1,11.4-12.512,18.1,18.1,0,0,0,4.7-.873,27.1,27.1,0,0,0,3.259-2.185,9.3,9.3,0,0,1,11.5,1.554c2.655,2.932,3.335-1.462,9.317,1.538,4.955,2.485,2.757,6.594,2.757,6.594A10.674,10.674,0,0,1,363.5,202.98c.784,3.025.427,6.8,2.96,8.632,1.228.887,2.861,1.039,4.124,1.877,2.346,1.557,2.661,4.864,2.357,7.663s-.956,5.78.257,8.32c1.99,4.165,8.213,5.429,9.292,9.917.51,2.119-.208,4.755,1.4,6.228a7.423,7.423,0,0,0,2.341,1.155,9.732,9.732,0,0,1,1.6,17.218c-.834.535-1.833,1.043-2.1,2-.3,1.064.47,2.092,1.033,3.042a9.358,9.358,0,0,1-12.407,13.053,14.64,14.64,0,0,1-8.089,7.428,8.888,8.888,0,0,1-5.087.5,10.17,10.17,0,0,1-3.657-1.909c-5.275-3.969-12.713-10.089-13.642-16.625",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6685",
    "data-name": "Group 6685"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6684",
    "data-name": "Group 6684"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5361",
    "data-name": "Path 5361",
    d: "M309.3,211.378l-.238-4.68,27.957-6.222c8.643-1.186,18.289,7.214,19.108,15.9.909,9.65,1.638,21.467.716,28.716-1.853,14.578-12.914,16.769-12.914,16.769l.385,14.4-32.068,1.4Z",
    fill: "#a36957"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6695",
    "data-name": "Group 6695"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6694",
    "data-name": "Group 6694"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6693",
    "data-name": "Group 6693"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6692",
    "data-name": "Group 6692"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6691",
    "data-name": "Group 6691"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6690",
    "data-name": "Group 6690"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6689",
    "data-name": "Group 6689"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6688",
    "data-name": "Group 6688"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6687",
    "data-name": "Group 6687"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6686",
    "data-name": "Group 6686"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5362",
    "data-name": "Path 5362",
    d: "M350.859,226.915a1.862,1.862,0,0,1-1.736,1.933,1.782,1.782,0,0,1-1.97-1.618,1.863,1.863,0,0,1,1.734-1.934A1.783,1.783,0,0,1,350.859,226.915Z",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6706",
    "data-name": "Group 6706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6705",
    "data-name": "Group 6705"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6704",
    "data-name": "Group 6704"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6703",
    "data-name": "Group 6703"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6702",
    "data-name": "Group 6702"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6701",
    "data-name": "Group 6701"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6700",
    "data-name": "Group 6700"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6699",
    "data-name": "Group 6699"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6698",
    "data-name": "Group 6698"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6697",
    "data-name": "Group 6697"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6696",
    "data-name": "Group 6696"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5363",
    "data-name": "Path 5363",
    d: "M353.245,222.632c-.223.25-1.665-.749-3.667-.682-2,.039-3.437,1.114-3.662.876-.11-.105.111-.551.737-1.036a5.1,5.1,0,0,1,2.922-1,4.9,4.9,0,0,1,2.928.846C353.133,222.088,353.356,222.52,353.245,222.632Z",
    fill: "#263238"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6716",
    "data-name": "Group 6716"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6715",
    "data-name": "Group 6715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6714",
    "data-name": "Group 6714"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6713",
    "data-name": "Group 6713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6712",
    "data-name": "Group 6712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6711",
    "data-name": "Group 6711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6710",
    "data-name": "Group 6710"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6709",
    "data-name": "Group 6709"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6708",
    "data-name": "Group 6708"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6707",
    "data-name": "Group 6707"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5364",
    "data-name": "Path 5364",
    d: "M332.171,227.853a1.86,1.86,0,0,1-1.735,1.932,1.78,1.78,0,0,1-1.97-1.617,1.863,1.863,0,0,1,1.734-1.934A1.781,1.781,0,0,1,332.171,227.853Z",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6727",
    "data-name": "Group 6727"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6726",
    "data-name": "Group 6726"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6725",
    "data-name": "Group 6725"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6724",
    "data-name": "Group 6724"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6723",
    "data-name": "Group 6723"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6722",
    "data-name": "Group 6722"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6721",
    "data-name": "Group 6721"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6720",
    "data-name": "Group 6720"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6719",
    "data-name": "Group 6719"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6718",
    "data-name": "Group 6718"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6717",
    "data-name": "Group 6717"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5365",
    "data-name": "Path 5365",
    d: "M333.579,223.616c-.224.25-1.667-.749-3.667-.682-2,.039-3.438,1.114-3.663.876-.109-.1.109-.55.737-1.036a5.1,5.1,0,0,1,2.922-1,4.908,4.908,0,0,1,2.929.845C333.465,223.072,333.688,223.5,333.579,223.616Z",
    fill: "#263238"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6737",
    "data-name": "Group 6737"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6736",
    "data-name": "Group 6736"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6735",
    "data-name": "Group 6735"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6734",
    "data-name": "Group 6734"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6733",
    "data-name": "Group 6733"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6732",
    "data-name": "Group 6732"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6731",
    "data-name": "Group 6731"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6730",
    "data-name": "Group 6730"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6729",
    "data-name": "Group 6729"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6728",
    "data-name": "Group 6728"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5366",
    "data-name": "Path 5366",
    d: "M341.3,238.237a13.281,13.281,0,0,1,3.233-.687c.509-.069.99-.185,1.066-.537a2.6,2.6,0,0,0-.389-1.505l-1.632-3.845c-2.272-5.477-3.933-9.987-3.711-10.077s2.242,4.277,4.513,9.754q.822,2.026,1.57,3.871a2.964,2.964,0,0,1,.327,2,1.281,1.281,0,0,1-.817.774,3.477,3.477,0,0,1-.865.147A13.016,13.016,0,0,1,341.3,238.237Z",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6746",
    "data-name": "Group 6746"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6745",
    "data-name": "Group 6745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6744",
    "data-name": "Group 6744"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6743",
    "data-name": "Group 6743"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6742",
    "data-name": "Group 6742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6741",
    "data-name": "Group 6741"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6740",
    "data-name": "Group 6740"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6739",
    "data-name": "Group 6739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6738",
    "data-name": "Group 6738"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5367",
    "data-name": "Path 5367",
    d: "M343.919,261.9a38.422,38.422,0,0,1-20.084-4.594s5.214,10.005,20.187,8.211Z",
    fill: "#7c3b29"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6755",
    "data-name": "Group 6755"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6754",
    "data-name": "Group 6754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6753",
    "data-name": "Group 6753"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6752",
    "data-name": "Group 6752"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6751",
    "data-name": "Group 6751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6750",
    "data-name": "Group 6750"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6749",
    "data-name": "Group 6749"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6748",
    "data-name": "Group 6748"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6747",
    "data-name": "Group 6747"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5368",
    "data-name": "Path 5368",
    d: "M340.608,243.088a3.61,3.61,0,0,0-3.276-1.239,3.293,3.293,0,0,0-2.236,1.29,2.089,2.089,0,0,0-.085,2.391,2.424,2.424,0,0,0,2.645.583,7.593,7.593,0,0,0,2.512-1.607,2.21,2.21,0,0,0,.553-.61.668.668,0,0,0-.026-.745",
    fill: "#7c3b29"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6765",
    "data-name": "Group 6765"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6764",
    "data-name": "Group 6764"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6763",
    "data-name": "Group 6763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6762",
    "data-name": "Group 6762"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6761",
    "data-name": "Group 6761"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6760",
    "data-name": "Group 6760"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6759",
    "data-name": "Group 6759"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6758",
    "data-name": "Group 6758"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6757",
    "data-name": "Group 6757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6756",
    "data-name": "Group 6756"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5369",
    "data-name": "Path 5369",
    d: "M335.456,239.8c.325-.029.4,2.144,2.3,3.628s4.214,1.174,4.24,1.477c.035.136-.5.438-1.479.495a5.415,5.415,0,0,1-3.536-1.11,4.71,4.71,0,0,1-1.792-3.047C335.081,240.343,335.307,239.8,335.456,239.8Z",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6771",
    "data-name": "Group 6771"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6770",
    "data-name": "Group 6770"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6769",
    "data-name": "Group 6769"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6768",
    "data-name": "Group 6768"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6767",
    "data-name": "Group 6767"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6766",
    "data-name": "Group 6766"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5370",
    "data-name": "Path 5370",
    d: "M333.852,215.755c-.18.55-2.187.354-4.527.71-2.347.309-4.219,1.056-4.546.577-.147-.229.168-.751.917-1.3a7.96,7.96,0,0,1,6.913-.981C333.482,215.08,333.929,215.494,333.852,215.755Z",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6777",
    "data-name": "Group 6777"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6776",
    "data-name": "Group 6776"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6775",
    "data-name": "Group 6775"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6774",
    "data-name": "Group 6774"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6773",
    "data-name": "Group 6773"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6772",
    "data-name": "Group 6772"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5371",
    "data-name": "Path 5371",
    d: "M352.33,216.861c-.339.466-1.732.037-3.391.066-1.66-.029-3.053.4-3.392-.065-.148-.227.059-.689.659-1.138a4.909,4.909,0,0,1,5.464,0C352.271,216.172,352.478,216.635,352.33,216.861Z",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6779",
    "data-name": "Group 6779"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6778",
    "data-name": "Group 6778"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5372",
    "data-name": "Path 5372",
    d: "M358.582,198.582c-1.963,5.228-6.645,13.134-12.149,14.076a16.4,16.4,0,0,1-15.027-5.512c-.637,4.17-5.112,6.586-9.237,7.471a16.582,16.582,0,0,1-8.835-.166,8.782,8.782,0,0,1-5.9-6.19c-.59-2.924,3.247-10.363,6.149-11.054",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6781",
    "data-name": "Group 6781"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6780",
    "data-name": "Group 6780"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5373",
    "data-name": "Path 5373",
    d: "M318.748,275.744a11.428,11.428,0,0,1-7.622,10.716,8.1,8.1,0,0,1-15.411,4.264,9.709,9.709,0,0,0-1.353-2.655c-1.545-1.692-4.282-1.139-6.507-1.687-4.008-.987-6.049-5.667-5.9-9.792a9.558,9.558,0,0,0-.058-2.433c-.362-1.626-1.736-2.788-2.791-4.077-4.34-5.3-3.279-13.528.712-19.1,1.331-1.857,3.037-3.82,2.74-6.085a12.228,12.228,0,0,0-1.494-3.5,10.353,10.353,0,0,1,1.978-11.469,3.261,3.261,0,0,0,1.09-1.524,3.153,3.153,0,0,0-.094-1.2,12.108,12.108,0,0,1,9.286-13.629,3.021,3.021,0,0,0,1.049-.316c.9-.552.832-1.834.88-2.885.125-2.774,1.884-8.064,3.861-10.014,5.48-5.406,11.43-1.753,13.584,0,0,0,5.418,19.528,4.909,23.272s-2.561,13.143-1.187,17.244,3.748,12.535,2.329,16.424S318.748,275.744,318.748,275.744Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7018",
    "data-name": "Group 7018"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6871",
    "data-name": "Group 6871"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6790",
    "data-name": "Group 6790"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6789",
    "data-name": "Group 6789"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6788",
    "data-name": "Group 6788"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6787",
    "data-name": "Group 6787"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6786",
    "data-name": "Group 6786"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6785",
    "data-name": "Group 6785"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6784",
    "data-name": "Group 6784"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6783",
    "data-name": "Group 6783"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5374",
    "data-name": "Path 5374",
    d: "M353.921,438.4s42.341,11.718,44.039,12.316c2.551.9,2.123,10.243-1.847,10.1-1.877-.069-32.522,1.141-36.394.9s-15.553-4.845-15.553-4.845Z",
    fill: "#ff725e"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6799",
    "data-name": "Group 6799"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6798",
    "data-name": "Group 6798"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6797",
    "data-name": "Group 6797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6796",
    "data-name": "Group 6796"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6795",
    "data-name": "Group 6795"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6794",
    "data-name": "Group 6794"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6793",
    "data-name": "Group 6793"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6792",
    "data-name": "Group 6792"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6791",
    "data-name": "Group 6791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5375",
    "data-name": "Path 5375",
    d: "M371.559,454.554c.213.03.5-2.21,1.866-4.546,1.333-2.356,3.126-3.727,2.994-3.9-.074-.163-2.177,1.03-3.608,3.544C371.356,452.154,371.381,454.573,371.559,454.554Z",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6808",
    "data-name": "Group 6808"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6807",
    "data-name": "Group 6807"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6806",
    "data-name": "Group 6806"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6805",
    "data-name": "Group 6805"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6804",
    "data-name": "Group 6804"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6803",
    "data-name": "Group 6803"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6802",
    "data-name": "Group 6802"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6801",
    "data-name": "Group 6801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6800",
    "data-name": "Group 6800"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5376",
    "data-name": "Path 5376",
    d: "M367.145,452.553c.207.036.636-1.966,1.763-4.178,1.106-2.223,2.459-3.76,2.306-3.9-.117-.138-1.771,1.246-2.939,3.587C367.091,450.388,366.964,452.542,367.145,452.553Z",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6817",
    "data-name": "Group 6817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6816",
    "data-name": "Group 6816"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6815",
    "data-name": "Group 6815"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6814",
    "data-name": "Group 6814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6813",
    "data-name": "Group 6813"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6812",
    "data-name": "Group 6812"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6811",
    "data-name": "Group 6811"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6810",
    "data-name": "Group 6810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6809",
    "data-name": "Group 6809"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5377",
    "data-name": "Path 5377",
    d: "M363,451.443c.213-.012.051-2.128.99-4.473.9-2.361,2.454-3.8,2.306-3.959-.085-.161-1.983,1.148-2.966,3.7C362.325,449.254,362.832,451.5,363,451.443Z",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6826",
    "data-name": "Group 6826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6825",
    "data-name": "Group 6825"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6824",
    "data-name": "Group 6824"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6823",
    "data-name": "Group 6823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6822",
    "data-name": "Group 6822"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6821",
    "data-name": "Group 6821"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6820",
    "data-name": "Group 6820"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6819",
    "data-name": "Group 6819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6818",
    "data-name": "Group 6818"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5378",
    "data-name": "Path 5378",
    d: "M363.755,445.975a7.491,7.491,0,0,0,.454-3.151,14.8,14.8,0,0,0-.428-3.452,14.551,14.551,0,0,0-.631-1.966,2.36,2.36,0,0,0-.678-1.037,1.128,1.128,0,0,0-1.454.071,1.87,1.87,0,0,0-.564,1.2,8.225,8.225,0,0,0-.055,1.118,9.332,9.332,0,0,0,.261,2.073,12.628,12.628,0,0,0,1.3,3.237,8.538,8.538,0,0,0,1.9,2.548c.1-.067-.612-1.053-1.457-2.78a13.88,13.88,0,0,1-1.111-3.148,9.375,9.375,0,0,1-.2-1.934c.019-.651.01-1.464.39-1.777a.41.41,0,0,1,.56-.047,1.781,1.781,0,0,1,.464.74,15.5,15.5,0,0,1,.642,1.868,17.025,17.025,0,0,1,.56,3.306C363.833,444.759,363.64,445.958,363.755,445.975Z",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6835",
    "data-name": "Group 6835"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6834",
    "data-name": "Group 6834"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6833",
    "data-name": "Group 6833"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6832",
    "data-name": "Group 6832"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6831",
    "data-name": "Group 6831"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6830",
    "data-name": "Group 6830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6829",
    "data-name": "Group 6829"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6828",
    "data-name": "Group 6828"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6827",
    "data-name": "Group 6827"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5379",
    "data-name": "Path 5379",
    d: "M363.7,445.544a5.926,5.926,0,0,0-2.731-.441,12.331,12.331,0,0,0-3,.368,6.6,6.6,0,0,0-1.73.638,1.786,1.786,0,0,0-.957,1.935,2.116,2.116,0,0,0,1.526,1.511,3.878,3.878,0,0,0,1.9-.005,7.3,7.3,0,0,0,2.751-1.353,7.457,7.457,0,0,0,1.969-1.938,18.617,18.617,0,0,0-2.256,1.528,7.517,7.517,0,0,1-2.6,1.124,3.345,3.345,0,0,1-1.57-.022,1.432,1.432,0,0,1-1.031-1.007,1.09,1.09,0,0,1,.629-1.181,6.446,6.446,0,0,1,1.536-.6,14.207,14.207,0,0,1,2.853-.5C362.646,445.488,363.685,445.658,363.7,445.544Z",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6844",
    "data-name": "Group 6844"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6843",
    "data-name": "Group 6843"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6842",
    "data-name": "Group 6842"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6841",
    "data-name": "Group 6841"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6840",
    "data-name": "Group 6840"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6839",
    "data-name": "Group 6839"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6838",
    "data-name": "Group 6838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6837",
    "data-name": "Group 6837"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6836",
    "data-name": "Group 6836"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5380",
    "data-name": "Path 5380",
    d: "M378.065,455.008c.21-.024,0-1.834.835-3.819.793-2,2.206-3.151,2.073-3.315-.07-.172-1.841.831-2.729,3.048C377.33,453.127,377.894,455.083,378.065,455.008Z",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6853",
    "data-name": "Group 6853"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6852",
    "data-name": "Group 6852"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6851",
    "data-name": "Group 6851"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6850",
    "data-name": "Group 6850"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6849",
    "data-name": "Group 6849"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6848",
    "data-name": "Group 6848"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6847",
    "data-name": "Group 6847"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6846",
    "data-name": "Group 6846"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6845",
    "data-name": "Group 6845"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5381",
    "data-name": "Path 5381",
    d: "M348.521,456.962a8.864,8.864,0,0,0,1.638.771,36.319,36.319,0,0,0,4.712,1.46,67.238,67.238,0,0,0,16.165,1.532c6.345-.07,12.063-.359,16.209-.524l4.907-.26a9.007,9.007,0,0,0,1.8-.192,8.773,8.773,0,0,0-1.8-.084l-4.913.035-16.2.316a75.683,75.683,0,0,1-16.051-1.312C350.934,457.873,348.57,456.831,348.521,456.962Z",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6862",
    "data-name": "Group 6862"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6861",
    "data-name": "Group 6861"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6860",
    "data-name": "Group 6860"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6859",
    "data-name": "Group 6859"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6858",
    "data-name": "Group 6858"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6857",
    "data-name": "Group 6857"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6856",
    "data-name": "Group 6856"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6855",
    "data-name": "Group 6855"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6854",
    "data-name": "Group 6854"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5382",
    "data-name": "Path 5382",
    d: "M347.269,457.927c.058.1,1.216-.579,3.172-1.437a14.754,14.754,0,0,1,8.012-1.332c3.191.489,5.453,2.632,6.926,4.12a24.758,24.758,0,0,0,2.44,2.492,13.18,13.18,0,0,0-2.072-2.832,16.773,16.773,0,0,0-2.808-2.625,10.05,10.05,0,0,0-4.374-1.854,14,14,0,0,0-8.335,1.577A11.246,11.246,0,0,0,347.269,457.927Z",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6870",
    "data-name": "Group 6870",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6869",
    "data-name": "Group 6869"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6868",
    "data-name": "Group 6868"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6867",
    "data-name": "Group 6867"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6866",
    "data-name": "Group 6866"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6865",
    "data-name": "Group 6865"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6864",
    "data-name": "Group 6864"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6863",
    "data-name": "Group 6863"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5383",
    "data-name": "Path 5383",
    d: "M353.921,438.4s42.341,11.718,44.039,12.316c2.551.9,2.123,10.243-1.847,10.1-1.877-.069-32.522,1.141-36.394.9s-15.553-4.845-15.553-4.845Z"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6929",
    "data-name": "Group 6929"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6924",
    "data-name": "Group 6924"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6876",
    "data-name": "Group 6876"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6875",
    "data-name": "Group 6875"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6874",
    "data-name": "Group 6874"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6873",
    "data-name": "Group 6873"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6872",
    "data-name": "Group 6872"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5384",
    "data-name": "Path 5384",
    d: "M306.883,389.767l-9.142,18.784s-48.871-14.861-61.185-14.177-22.4,5.617-24.794,15.617-2.722,23.8,11.644,33.378,85.761,14.868,85.761,14.868h28.252L383.6,397.352l-7.439-6.033Z",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6882",
    "data-name": "Group 6882"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6881",
    "data-name": "Group 6881"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6880",
    "data-name": "Group 6880"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6879",
    "data-name": "Group 6879"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6878",
    "data-name": "Group 6878"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6877",
    "data-name": "Group 6877"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5385",
    "data-name": "Path 5385",
    d: "M322.251,430.974a5.251,5.251,0,0,1-.927-.016c-.605-.049-1.507-.045-2.652-.206a55.079,55.079,0,0,1-9.578-1.977,92.071,92.071,0,0,1-13.507-5.283c-4.94-2.33-10.211-5.2-15.749-8.173a163.025,163.025,0,0,0-15.953-7.652,71.468,71.468,0,0,0-13.8-4.127,48.716,48.716,0,0,0-9.675-.844c-1.151-.026-2.039.1-2.646.1a5.132,5.132,0,0,1-.929.011,5.344,5.344,0,0,1,.917-.135c.6-.046,1.495-.207,2.651-.219a45.294,45.294,0,0,1,9.757.656,69.41,69.41,0,0,1,13.936,4.029,155.317,155.317,0,0,1,16.033,7.637c5.543,2.976,10.795,5.854,15.7,8.2a96.069,96.069,0,0,0,13.389,5.378,60.5,60.5,0,0,0,9.483,2.155c1.135.2,2.03.231,2.631.32A5.377,5.377,0,0,1,322.251,430.974Z",
    fill: "#455a64"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6887",
    "data-name": "Group 6887"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6886",
    "data-name": "Group 6886"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6885",
    "data-name": "Group 6885"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6884",
    "data-name": "Group 6884"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6883",
    "data-name": "Group 6883"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5386",
    "data-name": "Path 5386",
    d: "M355.644,453.267c9.075-3.566,58.992-19.448,76.662-39.869a19.541,19.541,0,0,0,4.839-16.951c-2.465-13.618-14.991-22.7-27.984-17.553-1.847.732-6.094,2.381-7.867,3.335-4.846,2.605-83.372,52.406-83.372,52.406s13.682,26.68,13.34,27.706Z",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6893",
    "data-name": "Group 6893"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6892",
    "data-name": "Group 6892"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6891",
    "data-name": "Group 6891"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6890",
    "data-name": "Group 6890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6889",
    "data-name": "Group 6889"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6888",
    "data-name": "Group 6888"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5387",
    "data-name": "Path 5387",
    d: "M380.228,394.062c.006.009-.066.067-.213.17-.178.122-.394.269-.658.447l-2.561,1.67-9.482,6.041-31.4,19.736-17.059,10.636.111-.35,8.945,21.521c1.061,2.606,1.909,4.69,2.515,6.176.268.686.482,1.232.646,1.651a3.026,3.026,0,0,1,.194.581,3.021,3.021,0,0,1-.28-.544l-.729-1.616c-.641-1.472-1.54-3.534-2.663-6.115-2.265-5.305-5.434-12.728-9.15-21.434l-.1-.222.206-.129,17.034-10.675,31.5-19.583,9.585-5.877,2.623-1.571.69-.4A.922.922,0,0,1,380.228,394.062Z",
    fill: "#455a64"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6899",
    "data-name": "Group 6899"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6898",
    "data-name": "Group 6898"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6897",
    "data-name": "Group 6897"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6896",
    "data-name": "Group 6896"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6895",
    "data-name": "Group 6895"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6894",
    "data-name": "Group 6894"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5388",
    "data-name": "Path 5388",
    d: "M311.258,417.609a8.146,8.146,0,0,1-2.319-.871,32.464,32.464,0,0,1-9.6-7.032,8.148,8.148,0,0,1-1.532-1.946c.141-.129,2.639,2.7,6.372,5.412C307.887,415.909,311.338,417.436,311.258,417.609Z",
    fill: "#455a64"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6905",
    "data-name": "Group 6905"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6904",
    "data-name": "Group 6904"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6903",
    "data-name": "Group 6903"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6902",
    "data-name": "Group 6902"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6901",
    "data-name": "Group 6901"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6900",
    "data-name": "Group 6900"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5389",
    "data-name": "Path 5389",
    d: "M338.444,395.475a18.951,18.951,0,0,1,.119,3.126c.027,1.925.1,4.582.367,7.5s.668,5.549.986,7.448a18.858,18.858,0,0,1,.445,3.1,13.643,13.643,0,0,1-.87-3.012,58.087,58.087,0,0,1-1.362-15.041A13.716,13.716,0,0,1,338.444,395.475Z",
    fill: "#455a64"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6911",
    "data-name": "Group 6911"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6910",
    "data-name": "Group 6910"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6909",
    "data-name": "Group 6909"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6908",
    "data-name": "Group 6908"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6907",
    "data-name": "Group 6907"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6906",
    "data-name": "Group 6906"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5390",
    "data-name": "Path 5390",
    d: "M344.283,394.829c0-.029.232-.056.613.084a2.757,2.757,0,0,1,1.3,1.092,3,3,0,0,1,.37,2.515,2.733,2.733,0,0,1-2.533,1.783,2.662,2.662,0,0,1-2.676-1.56,2.783,2.783,0,0,1,.348-2.523,2.436,2.436,0,0,1,1.366-1.015c.4-.1.624-.028.622,0a2.908,2.908,0,0,0-1.621,1.247,2.412,2.412,0,0,0-.193,2.077A2.128,2.128,0,0,0,344,399.69a2.2,2.2,0,0,0,2.03-1.357,2.647,2.647,0,0,0-.21-2.106A3.69,3.69,0,0,0,344.283,394.829Z",
    fill: "#455a64"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6917",
    "data-name": "Group 6917"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6916",
    "data-name": "Group 6916"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6915",
    "data-name": "Group 6915"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6914",
    "data-name": "Group 6914"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6913",
    "data-name": "Group 6913"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6912",
    "data-name": "Group 6912"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5391",
    "data-name": "Path 5391",
    d: "M320.133,392.854a2.675,2.675,0,0,1,.429.927,8.425,8.425,0,0,1,.411,2.761,9.935,9.935,0,0,1-.91,4.053,9.08,9.08,0,0,1-8.116,5.459,9.946,9.946,0,0,1-4.1-.686,8.419,8.419,0,0,1-2.4-1.421c-.5-.435-.721-.723-.7-.747a15.039,15.039,0,0,0,3.25,1.762,10.1,10.1,0,0,0,3.917.527,8.782,8.782,0,0,0,7.634-5.134,10.1,10.1,0,0,0,.988-3.827A15.025,15.025,0,0,0,320.133,392.854Z",
    fill: "#455a64"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6923",
    "data-name": "Group 6923"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6922",
    "data-name": "Group 6922"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6921",
    "data-name": "Group 6921"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6920",
    "data-name": "Group 6920"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6919",
    "data-name": "Group 6919"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6918",
    "data-name": "Group 6918"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5392",
    "data-name": "Path 5392",
    d: "M366.709,402.15a3.239,3.239,0,0,1-1.853-.261,7.015,7.015,0,0,1-4.682-7.17,3.229,3.229,0,0,1,.506-1.8c.1.026-.089.71-.072,1.814a7.377,7.377,0,0,0,4.41,6.755C366.023,401.946,366.723,402.051,366.709,402.15Z",
    fill: "#455a64"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6928",
    "data-name": "Group 6928"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6927",
    "data-name": "Group 6927"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6926",
    "data-name": "Group 6926"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6925",
    "data-name": "Group 6925"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5393",
    "data-name": "Path 5393",
    d: "M391.125,439.488a2.2,2.2,0,0,1,.3-.162l.9-.438,3.461-1.667c3-1.46,7.345-3.561,12.589-6.4a96.342,96.342,0,0,0,17.378-11.563,51.394,51.394,0,0,0,8.312-9.052,20.1,20.1,0,0,0,3.01-12.556,19.733,19.733,0,0,0-1.653-6.43,17.232,17.232,0,0,0-1.611-2.829,22.8,22.8,0,0,0-2.057-2.471,54.581,54.581,0,0,0-4.673-4.213,14.07,14.07,0,0,0-5.094-3.045,19,19,0,0,0-5.65-.626,29.064,29.064,0,0,0-5.362.593,32.749,32.749,0,0,0-9.051,3.42L389.568,388.9,386.2,390.75l-.88.472a2.057,2.057,0,0,1-.307.149,2.143,2.143,0,0,1,.287-.185l.86-.507,3.329-1.917c2.9-1.647,7.074-4.066,12.3-6.962a32.851,32.851,0,0,1,9.118-3.5,29.317,29.317,0,0,1,5.424-.621,19.333,19.333,0,0,1,5.763.625,14.417,14.417,0,0,1,5.234,3.1,54.688,54.688,0,0,1,4.714,4.237,23.3,23.3,0,0,1,2.1,2.513,17.578,17.578,0,0,1,1.651,2.894,20.113,20.113,0,0,1,1.69,6.563,20.454,20.454,0,0,1-3.083,12.809,51.44,51.44,0,0,1-8.4,9.115,95.18,95.18,0,0,1-17.486,11.534c-5.269,2.807-9.637,4.868-12.658,6.286l-3.493,1.6-.915.4A2.049,2.049,0,0,1,391.125,439.488Z",
    fill: "#455a64"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7017",
    "data-name": "Group 7017"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7010",
    "data-name": "Group 7010"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6937",
    "data-name": "Group 6937"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6936",
    "data-name": "Group 6936"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6935",
    "data-name": "Group 6935"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6934",
    "data-name": "Group 6934"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6933",
    "data-name": "Group 6933"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6932",
    "data-name": "Group 6932"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6931",
    "data-name": "Group 6931"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6930",
    "data-name": "Group 6930"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5394",
    "data-name": "Path 5394",
    d: "M321.218,438.663s-42.482,11.2-44.188,11.771c-2.562.867-2.249,10.216,1.722,10.12,1.878-.046,32.5,1.543,36.38,1.349s14.344-4.182,14.344-4.182Z",
    fill: "#ff725e"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6946",
    "data-name": "Group 6946"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6945",
    "data-name": "Group 6945"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6944",
    "data-name": "Group 6944"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6943",
    "data-name": "Group 6943"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6942",
    "data-name": "Group 6942"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6941",
    "data-name": "Group 6941"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6940",
    "data-name": "Group 6940"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6939",
    "data-name": "Group 6939"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6938",
    "data-name": "Group 6938"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5395",
    "data-name": "Path 5395",
    d: "M303.381,454.6c-.213.026-.471-2.217-1.809-4.569-1.3-2.372-3.08-3.766-2.945-3.934.076-.163,2.164,1.057,3.563,3.588C303.614,452.2,303.56,454.62,303.381,454.6Z",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6955",
    "data-name": "Group 6955"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6954",
    "data-name": "Group 6954"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6953",
    "data-name": "Group 6953"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6952",
    "data-name": "Group 6952"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6951",
    "data-name": "Group 6951"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6950",
    "data-name": "Group 6950"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6949",
    "data-name": "Group 6949"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6948",
    "data-name": "Group 6948"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6947",
    "data-name": "Group 6947"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5396",
    "data-name": "Path 5396",
    d: "M307.82,452.653c-.207.033-.611-1.974-1.712-4.2-1.078-2.237-2.411-3.79-2.257-3.933.119-.138,1.755,1.267,2.894,3.622C307.9,450.489,308,452.644,307.82,452.653Z",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6964",
    "data-name": "Group 6964"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6963",
    "data-name": "Group 6963"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6962",
    "data-name": "Group 6962"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6961",
    "data-name": "Group 6961"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6960",
    "data-name": "Group 6960"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6959",
    "data-name": "Group 6959"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6958",
    "data-name": "Group 6958"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6957",
    "data-name": "Group 6957"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6956",
    "data-name": "Group 6956"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5397",
    "data-name": "Path 5397",
    d: "M311.975,451.6c-.214-.016-.025-2.129-.935-4.485-.871-2.373-2.407-3.835-2.257-3.988.087-.16,1.969,1.173,2.92,3.738C312.681,449.414,312.145,451.658,311.975,451.6Z",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6973",
    "data-name": "Group 6973"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6972",
    "data-name": "Group 6972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6971",
    "data-name": "Group 6971"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6970",
    "data-name": "Group 6970"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6969",
    "data-name": "Group 6969"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6968",
    "data-name": "Group 6968"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6967",
    "data-name": "Group 6967"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6966",
    "data-name": "Group 6966"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6965",
    "data-name": "Group 6965"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5398",
    "data-name": "Path 5398",
    d: "M311.291,446.117a7.5,7.5,0,0,1-.415-3.156,14.844,14.844,0,0,1,.471-3.447,14.6,14.6,0,0,1,.655-1.957,2.359,2.359,0,0,1,.691-1.029,1.129,1.129,0,0,1,1.453.089,1.873,1.873,0,0,1,.549,1.2,8.177,8.177,0,0,1,.041,1.119,9.328,9.328,0,0,1-.287,2.069,12.561,12.561,0,0,1-1.343,3.22,8.541,8.541,0,0,1-1.933,2.526c-.1-.069.625-1.046,1.492-2.763a13.886,13.886,0,0,0,1.149-3.134,9.315,9.315,0,0,0,.228-1.931c-.011-.651.009-1.464-.368-1.782a.411.411,0,0,0-.559-.054,1.8,1.8,0,0,0-.474.734,15.622,15.622,0,0,0-.664,1.86,17.044,17.044,0,0,0-.6,3.3C311.228,444.9,311.406,446.1,311.291,446.117Z",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6982",
    "data-name": "Group 6982"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6981",
    "data-name": "Group 6981"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6980",
    "data-name": "Group 6980"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6979",
    "data-name": "Group 6979"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6978",
    "data-name": "Group 6978"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6977",
    "data-name": "Group 6977"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6976",
    "data-name": "Group 6976"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6975",
    "data-name": "Group 6975"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6974",
    "data-name": "Group 6974"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5399",
    "data-name": "Path 5399",
    d: "M311.349,445.687a5.941,5.941,0,0,1,2.736-.407,12.34,12.34,0,0,1,3,.4,6.63,6.63,0,0,1,1.722.659,1.786,1.786,0,0,1,.932,1.947,2.113,2.113,0,0,1-1.543,1.492,3.88,3.88,0,0,1-1.9-.028,7.306,7.306,0,0,1-2.733-1.387,7.46,7.46,0,0,1-1.945-1.962,18.551,18.551,0,0,1,2.236,1.555,7.518,7.518,0,0,0,2.584,1.156,3.333,3.333,0,0,0,1.57,0,1.433,1.433,0,0,0,1.043-.994,1.09,1.09,0,0,0-.614-1.189,6.456,6.456,0,0,0-1.528-.618,14.2,14.2,0,0,0-2.847-.533C312.406,445.645,311.365,445.8,311.349,445.687Z",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6991",
    "data-name": "Group 6991"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6990",
    "data-name": "Group 6990"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6989",
    "data-name": "Group 6989"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6988",
    "data-name": "Group 6988"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6987",
    "data-name": "Group 6987"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6986",
    "data-name": "Group 6986"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6985",
    "data-name": "Group 6985"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6984",
    "data-name": "Group 6984"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6983",
    "data-name": "Group 6983"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5400",
    "data-name": "Path 5400",
    d: "M296.87,454.973c-.209-.027.021-1.834-.787-3.829-.768-2.012-2.167-3.178-2.032-3.34.072-.172,1.83.853,2.692,3.08C297.629,453.1,297.041,455.05,296.87,454.973Z",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7000",
    "data-name": "Group 7000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6999",
    "data-name": "Group 6999"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6998",
    "data-name": "Group 6998"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6997",
    "data-name": "Group 6997"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6996",
    "data-name": "Group 6996"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6995",
    "data-name": "Group 6995"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6994",
    "data-name": "Group 6994"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6993",
    "data-name": "Group 6993"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6992",
    "data-name": "Group 6992"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5401",
    "data-name": "Path 5401",
    d: "M326.388,457.292a8.716,8.716,0,0,1-1.647.75,36.093,36.093,0,0,1-4.73,1.4,67.146,67.146,0,0,1-16.182,1.332c-6.344-.148-12.058-.507-16.2-.725l-4.9-.32a8.881,8.881,0,0,1-1.794-.214,8.787,8.787,0,0,1,1.806-.062l4.912.1,16.193.517a75.755,75.755,0,0,0,16.066-1.114C323.964,458.173,326.341,457.16,326.388,457.292Z",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7009",
    "data-name": "Group 7009"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7008",
    "data-name": "Group 7008"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7007",
    "data-name": "Group 7007"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7006",
    "data-name": "Group 7006"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7005",
    "data-name": "Group 7005"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7004",
    "data-name": "Group 7004"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7003",
    "data-name": "Group 7003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7002",
    "data-name": "Group 7002"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7001",
    "data-name": "Group 7001"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5402",
    "data-name": "Path 5402",
    d: "M327.628,458.273c-.059.1-1.209-.6-3.154-1.476a14.739,14.739,0,0,0-7.995-1.431c-3.2.449-5.485,2.564-6.976,4.033a24.724,24.724,0,0,1-2.471,2.462,13.182,13.182,0,0,1,2.107-2.806,16.821,16.821,0,0,1,2.84-2.59,10.041,10.041,0,0,1,4.4-1.8,14,14,0,0,1,8.315,1.68A11.226,11.226,0,0,1,327.628,458.273Z",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7016",
    "data-name": "Group 7016"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7015",
    "data-name": "Group 7015"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7014",
    "data-name": "Group 7014"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7013",
    "data-name": "Group 7013"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7012",
    "data-name": "Group 7012"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7011",
    "data-name": "Group 7011"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5403",
    "data-name": "Path 5403",
    d: "M285.133,459.579c-.076-.053.292-.608.638-1.593a7.751,7.751,0,0,0-1.306-7.6c-.655-.813-1.187-1.213-1.133-1.288.034-.056.663.23,1.438,1.018a7.224,7.224,0,0,1,1.379,8.025C285.682,459.14,285.184,459.62,285.133,459.579Z",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7083",
    "data-name": "Group 7083"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7038",
    "data-name": "Group 7038"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7021",
    "data-name": "Group 7021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7020",
    "data-name": "Group 7020"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7019",
    "data-name": "Group 7019"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5404",
    "data-name": "Path 5404",
    d: "M319.261,273.666l-21.841,6.12,7.1,67.952s-4.083,24.26-4.083,30.636a12.673,12.673,0,0,0,6.447,11.393l69.773,2.107,3.567-3.087A10.068,10.068,0,0,0,382.552,381L369.589,277.32,345.3,272.051Z",
    fill: "#ff725e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7025",
    "data-name": "Group 7025"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7024",
    "data-name": "Group 7024"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7023",
    "data-name": "Group 7023"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7022",
    "data-name": "Group 7022"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5405",
    "data-name": "Path 5405",
    d: "M304.6,347.655a2.619,2.619,0,0,1-.13-.514l-.293-1.488c-.247-1.342-.588-3.2-1.007-5.483-.818-4.678-1.934-11.062-3.168-18.115-1.188-7.063-2.263-13.455-3.051-18.138-.366-2.289-.664-4.158-.88-5.506-.09-.618-.162-1.116-.218-1.5a2.7,2.7,0,0,1-.05-.528,2.56,2.56,0,0,1,.13.513c.075.38.173.874.294,1.487.246,1.342.587,3.2,1.006,5.482.818,4.679,1.935,11.064,3.169,18.12l3.051,18.138c.366,2.288.664,4.157.879,5.505.09.618.163,1.116.219,1.5A2.53,2.53,0,0,1,304.6,347.655Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7029",
    "data-name": "Group 7029"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7028",
    "data-name": "Group 7028"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7027",
    "data-name": "Group 7027"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7026",
    "data-name": "Group 7026"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5406",
    "data-name": "Path 5406",
    d: "M348.365,273.291a7.786,7.786,0,0,1-1.005.8c-.337.239-.775.492-1.274.8-.523.265-1.1.613-1.788.889a23.579,23.579,0,0,1-4.956,1.545,36.7,36.7,0,0,1-6.318.657,62.8,62.8,0,0,1-6.342-.2,36.621,36.621,0,0,1-5.142-.673,15.387,15.387,0,0,1-3.321-1.109,8.894,8.894,0,0,1-.836-.455c-.184-.116-.277-.182-.27-.194.017-.031.416.19,1.171.505a17.576,17.576,0,0,0,3.315.973,40.3,40.3,0,0,0,5.109.58c1.937.128,4.07.218,6.3.164a38.722,38.722,0,0,0,6.257-.618,24.859,24.859,0,0,0,4.916-1.443A29.64,29.64,0,0,0,348.365,273.291Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7033",
    "data-name": "Group 7033"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7032",
    "data-name": "Group 7032"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7031",
    "data-name": "Group 7031"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7030",
    "data-name": "Group 7030"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5407",
    "data-name": "Path 5407",
    d: "M370.924,378.083a2.14,2.14,0,0,1-.475.1l-1.373.2c-.6.086-1.327.18-2.18.253s-1.822.19-2.9.242c-2.15.154-4.718.221-7.569.18-2.85-.065-5.982-.253-9.251-.635-3.267-.4-6.356-.956-9.141-1.564-2.78-.634-5.26-1.3-7.313-1.962-1.035-.3-1.95-.641-2.76-.918s-1.5-.535-2.059-.76l-1.288-.516a2.192,2.192,0,0,1-.438-.2,2.215,2.215,0,0,1,.468.129l1.312.444c.567.2,1.262.442,2.078.694s1.734.573,2.77.858c2.057.62,4.536,1.26,7.31,1.871,2.779.586,5.856,1.128,9.109,1.527,3.256.38,6.373.578,9.211.664,2.839.06,5.4.024,7.544-.093,1.075-.033,2.043-.125,2.9-.181s1.585-.123,2.183-.185l1.38-.121A2.174,2.174,0,0,1,370.924,378.083Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7037",
    "data-name": "Group 7037"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7036",
    "data-name": "Group 7036"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7035",
    "data-name": "Group 7035"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7034",
    "data-name": "Group 7034"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5408",
    "data-name": "Path 5408",
    d: "M379.017,319.827a4.763,4.763,0,0,1-.333-.944c-.189-.615-.445-1.51-.747-2.619-.6-2.219-1.381-5.3-2.144-8.725s-1.365-6.547-1.758-8.812c-.2-1.133-.345-2.052-.434-2.689a4.662,4.662,0,0,1-.1-1,4.73,4.73,0,0,1,.255.968c.149.709.337,1.6.56,2.663.465,2.25,1.112,5.356,1.873,8.778s1.493,6.507,2.026,8.742c.248,1.056.456,1.944.622,2.649A4.811,4.811,0,0,1,379.017,319.827Z",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7065",
    "data-name": "Group 7065"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7064",
    "data-name": "Group 7064"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7042",
    "data-name": "Group 7042",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7041",
    "data-name": "Group 7041"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7040",
    "data-name": "Group 7040"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7039",
    "data-name": "Group 7039"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5409",
    "data-name": "Path 5409",
    d: "M326.884,276.753c.872,3.037.06,7.462.489,10.18a145.059,145.059,0,0,1,1.75,32.931,4.405,4.405,0,0,0,.112,1.785,5.384,5.384,0,0,0,.885,1.379c2.209,2.923,2.78,6.827,2.335,10.463a42.982,42.982,0,0,1-3.162,10.494c-.078-2.934.078-7.321.309-10.248.047-.584.345-.209.361-.794.1-3.519-.489-6.783-2.961-9.29a7.6,7.6,0,0,1-1.4-1.576,5.233,5.233,0,0,1-.476-1.879q-2.273-18.426-3.105-36.993a2.958,2.958,0,0,1,.4-2.02,5.383,5.383,0,0,1,1.361-.932c.946-.624,1.537-1.726,2.56-2.212"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7045",
    "data-name": "Group 7045"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7044",
    "data-name": "Group 7044"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7043",
    "data-name": "Group 7043"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5410",
    "data-name": "Path 5410",
    d: "M297.42,279.786s-19.941,4.7-15.105,34.588a184.817,184.817,0,0,0,11.9,42.439c3.266,7.691,10.67,12.984,18.955,11.9,3.62-.474,7.2.1,9.629-1.361,3.679-2.219,5.28-9.7,5.974-17.764.473-5.495.274-11.221,1-15.911,1.188-7.658-2.326-11.267-6.821-12.163L305.327,318l-1.015,9.324Z",
    fill: "#ff725e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7049",
    "data-name": "Group 7049"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7048",
    "data-name": "Group 7048"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7047",
    "data-name": "Group 7047"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7046",
    "data-name": "Group 7046"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5411",
    "data-name": "Path 5411",
    d: "M311.465,339.272c.05-.04.333.36,1.016.871a7.036,7.036,0,0,0,3.292,1.307,10.989,10.989,0,0,0,5.218-.744,16.656,16.656,0,0,0,5.635-3.246,9.95,9.95,0,0,0,2.927-5.638,9.725,9.725,0,0,0-.626-5.2,13.648,13.648,0,0,0-2.8-4.053,3.468,3.468,0,0,1,1.1.809,9.658,9.658,0,0,1,2.161,3.046,9.912,9.912,0,0,1,.811,5.493,10.376,10.376,0,0,1-3.084,6.053,16.605,16.605,0,0,1-5.9,3.348,11.053,11.053,0,0,1-5.513.624,6.776,6.776,0,0,1-3.389-1.588A2.663,2.663,0,0,1,311.465,339.272Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7053",
    "data-name": "Group 7053"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7052",
    "data-name": "Group 7052"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7051",
    "data-name": "Group 7051"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7050",
    "data-name": "Group 7050"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5412",
    "data-name": "Path 5412",
    d: "M293.143,354.192c.063-.022.374.941,1.194,2.555a22.83,22.83,0,0,0,4.542,6.1,21.511,21.511,0,0,0,9.76,5.4,21.832,21.832,0,0,0,13.505-.946c2.257-.914,3.073-3.423,3.937-5.516a36.455,36.455,0,0,0,1.682-6.467c.717-4.22.884-8.1,1.125-11.344.232-3.171.423-5.773.564-7.691.076-.842.139-1.532.189-2.089a2.878,2.878,0,0,1,.114-.725,2.912,2.912,0,0,1,.028.733c-.016.559-.034,1.252-.057,2.1-.085,1.921-.2,4.528-.341,7.7a103.315,103.315,0,0,1-.983,11.423,36.3,36.3,0,0,1-1.674,6.6,24.042,24.042,0,0,1-1.486,3.312,5.959,5.959,0,0,1-2.8,2.6,22.22,22.22,0,0,1-13.96.936,21.921,21.921,0,0,1-14.391-12.007,15.867,15.867,0,0,1-.766-1.962A2.9,2.9,0,0,1,293.143,354.192Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7057",
    "data-name": "Group 7057"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7056",
    "data-name": "Group 7056"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7055",
    "data-name": "Group 7055"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7054",
    "data-name": "Group 7054"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5413",
    "data-name": "Path 5413",
    d: "M299.786,341.232a18.273,18.273,0,0,1,.044-3.592c.118-2.211.328-5.262.6-8.629.146-1.687.26-3.277.436-4.755a7.466,7.466,0,0,1,1.358-3.75,4,4,0,0,1,2.261-1.475c.64-.13.995,0,.987.032,0,.064-.353.034-.916.232a4.049,4.049,0,0,0-1.934,1.511c-1.309,1.728-1.152,4.923-1.49,8.263-.276,3.366-.564,6.411-.808,8.612A18.138,18.138,0,0,1,299.786,341.232Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7059",
    "data-name": "Group 7059"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7058",
    "data-name": "Group 7058"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5414",
    "data-name": "Path 5414",
    d: "M306.01,309.483c-.178-.948-.457-2.313-.817-4-.72-3.369-1.763-8.012-2.957-13.132a73.538,73.538,0,0,0-1.894-7.193,16.692,16.692,0,0,0-2.922-5.374l-.386.314a17.094,17.094,0,0,1,2.694,5.27c.715,2.134,1.216,4.584,1.823,7.143,1.193,5.12,2.313,9.745,3.157,13.085.422,1.67.776,3.019,1.035,3.947a6.212,6.212,0,0,0,.473,1.426A6.1,6.1,0,0,0,306.01,309.483Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7063",
    "data-name": "Group 7063",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7062",
    "data-name": "Group 7062"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7061",
    "data-name": "Group 7061"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7060",
    "data-name": "Group 7060"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5415",
    "data-name": "Path 5415",
    d: "M306.2,315.913a7.8,7.8,0,0,0-4.487,1.516,14.91,14.91,0,0,0-5.937,8.4,17.416,17.416,0,0,0,.462,10.339c.363,1.029,1.068,2.2,2.159,2.153,1.283-.051,1.8-1.652,1.979-2.923q.738-5.285,1.477-10.568a9.814,9.814,0,0,1,.937-3.482,3.33,3.33,0,0,1,2.9-1.846q.165-1.881.328-3.762"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7079",
    "data-name": "Group 7079"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7067",
    "data-name": "Group 7067"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7066",
    "data-name": "Group 7066"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5416",
    "data-name": "Path 5416",
    d: "M424.882,331.988A29.554,29.554,0,0,0,429,318.155a46.218,46.218,0,0,0-1.956-15.206l-21.185-6.566-.134,7.072Z",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7069",
    "data-name": "Group 7069"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7068",
    "data-name": "Group 7068"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5417",
    "data-name": "Path 5417",
    d: "M405.725,303.455,369.589,277.32v1.81l3.9,40.689s29.873,13.382,37.787,15.353a15.764,15.764,0,0,0,13.6-3.184Z",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7072",
    "data-name": "Group 7072"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7071",
    "data-name": "Group 7071"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7070",
    "data-name": "Group 7070"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5418",
    "data-name": "Path 5418",
    d: "M416.44,323.216a2.848,2.848,0,0,1-.819-.432,14.333,14.333,0,0,1-1.988-1.551,22.254,22.254,0,0,1-4.827-6.74,44,44,0,0,1-2.754-7.814c-.268-1.024-.464-1.857-.588-2.436a3.2,3.2,0,0,1-.141-.912,24.707,24.707,0,0,1,1.083,3.246,56.076,56.076,0,0,0,2.869,7.69,24.6,24.6,0,0,0,4.613,6.7C415.367,322.452,416.492,323.138,416.44,323.216Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7075",
    "data-name": "Group 7075"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7074",
    "data-name": "Group 7074"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7073",
    "data-name": "Group 7073"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5419",
    "data-name": "Path 5419",
    d: "M426.937,308.07a3.209,3.209,0,0,1-.936.012,21.633,21.633,0,0,1-2.533-.276,30.943,30.943,0,0,1-15.1-7.016,21.8,21.8,0,0,1-1.845-1.758,3.241,3.241,0,0,1-.594-.723c.064-.063,1,.873,2.673,2.2a35.214,35.214,0,0,0,14.933,6.939C425.622,307.866,426.944,307.981,426.937,308.07Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7078",
    "data-name": "Group 7078"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7077",
    "data-name": "Group 7077"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7076",
    "data-name": "Group 7076"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5420",
    "data-name": "Path 5420",
    d: "M407.318,319.818a7.518,7.518,0,0,1-1.124-2.24,21.571,21.571,0,0,1-1.2-5.929,42.6,42.6,0,0,1,.047-6.036,11.192,11.192,0,0,1,.312-2.478,12.684,12.684,0,0,1,.056,2.494c-.016,1.536-.059,3.657.1,5.982a26.61,26.61,0,0,0,1.032,5.849C406.989,318.917,407.4,319.779,407.318,319.818Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7082",
    "data-name": "Group 7082"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7081",
    "data-name": "Group 7081"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7080",
    "data-name": "Group 7080"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5421",
    "data-name": "Path 5421",
    d: "M369.045,292.945a5.089,5.089,0,0,1,.377,1.107c.209.721.491,1.769.823,3.069.665,2.6,1.516,6.206,2.355,10.212s1.505,7.655,1.939,10.3c.217,1.324.379,2.4.476,3.141a5.113,5.113,0,0,1,.1,1.165,5.027,5.027,0,0,1-.3-1.13c-.173-.842-.386-1.881-.639-3.11-.557-2.742-1.283-6.312-2.085-10.261l-2.2-10.235c-.262-1.226-.483-2.264-.662-3.1A5.106,5.106,0,0,1,369.045,292.945Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7104",
    "data-name": "Group 7104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7086",
    "data-name": "Group 7086"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7085",
    "data-name": "Group 7085"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7084",
    "data-name": "Group 7084"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5422",
    "data-name": "Path 5422",
    d: "M305.105,321.684l4.429-49,14.674,5.794,1.889,49.836s-4.7,7.106-12.628,4.19A12.871,12.871,0,0,1,305.105,321.684Z",
    fill: "#a36957"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7089",
    "data-name": "Group 7089"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7088",
    "data-name": "Group 7088"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7087",
    "data-name": "Group 7087"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5423",
    "data-name": "Path 5423",
    d: "M307.961,229.777,335.4,253.91l-4.967,18.019-1.991.59-23.987-24.55,1.517-17.6Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7092",
    "data-name": "Group 7092"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7091",
    "data-name": "Group 7091"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7090",
    "data-name": "Group 7090"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5424",
    "data-name": "Path 5424",
    d: "M305.97,230.368,333.406,254.5l-4.967,18.019-25.977-23.96Z",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7095",
    "data-name": "Group 7095"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7094",
    "data-name": "Group 7094"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7093",
    "data-name": "Group 7093"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5425",
    "data-name": "Path 5425",
    d: "M324.827,280.052a10.691,10.691,0,0,0,2.757-6.744c-.063-3.693-1.082-12.58-1.082-12.58s4.766-10.033,4.646-11.367-.339-1.314-2.05-.776-7.023,9.685-7.023,9.685l-1.737-6.783s4.419-7.121,4.77-8.113.937-1.813-.172-1.9-9.4,7.954-9.4,7.954l.669,7.431s-.165.591-1.36-.454-.892-9.908-.892-9.908,2.828-5.249,2.759-6.011.518-1.583-.039-2.878-2.184.2-2.184.2l-5.509,7.219-1.963-7.144s.083-1.523-1.9-1.536l.767,23.173,5.02,17.83Z",
    fill: "#a36957"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7099",
    "data-name": "Group 7099"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7098",
    "data-name": "Group 7098"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7097",
    "data-name": "Group 7097"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7096",
    "data-name": "Group 7096"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5426",
    "data-name": "Path 5426",
    d: "M326.1,328.318s-.041-.3-.077-.873c-.032-.612-.078-1.461-.135-2.552-.1-2.276-.247-5.556-.433-9.728-.335-8.44-.813-20.484-1.392-35.059l-.006-.141.119-.1a9.589,9.589,0,0,0,2.654-3.751,10.957,10.957,0,0,0,.555-4.822c-.174-3.393-.6-6.923-1.067-10.529l-.013-.1.041-.088c.9-1.909,1.8-3.875,2.667-5.891.434-1.008.867-2.029,1.264-3.068.2-.519.387-1.044.538-1.567l.1-.386a2.829,2.829,0,0,0,.031-.323,2.354,2.354,0,0,0-.136-.7c.053-.162-.7,0-1.189.173a1.527,1.527,0,0,0-.648.33,4.664,4.664,0,0,0-.583.564,26.921,26.921,0,0,0-2.092,2.731c-1.319,1.919-2.567,3.938-3.777,5.994l-.432.733-.21-.822c-.551-2.148-1.142-4.455-1.739-6.782l-.037-.144.079-.129,2.241-3.664c.853-1.444,1.792-2.929,2.481-4.347.143-.4.34-.808.435-1.143.053-.184.022-.264.018-.247a.523.523,0,0,0-.333-.064,2.275,2.275,0,0,0-.4.2c-.164.09-.331.222-.5.33-.327.237-.654.486-.972.745-2.544,2.089-4.925,4.345-7.243,6.56l.1-.28q.338,3.771.664,7.432l.006.069-.017.054a.618.618,0,0,1-.659.411,1.329,1.329,0,0,1-.482-.151,3.681,3.681,0,0,1-.673-.47,2.737,2.737,0,0,1-.716-1.512,20.479,20.479,0,0,1-.333-2.967c-.1-1.958-.1-3.877-.045-5.777l0-.073.037-.071a49.665,49.665,0,0,0,2.659-5.526,1.622,1.622,0,0,0,.065-.275c.009-.081-.008-.288.013-.413.031-.284.093-.532.135-.769a2.647,2.647,0,0,0-.047-1.335c-.151-.486-.3-.685-.674-.618a2.712,2.712,0,0,0-1.117.627l.037-.04-5.524,7.208-.357.466-.154-.566q-1.011-3.709-1.946-7.148l-.01-.036v-.051a1.181,1.181,0,0,0-.5-.964,2.033,2.033,0,0,0-1.127-.293l.267-.273c.273,9.427.5,17.245.671,23.176l-.005-.038c1.1,4.258,1.949,7.554,2.535,9.823.271,1.091.481,1.934.632,2.54.137.571.185.869.185.869s-.107-.282-.273-.846c-.17-.6-.408-1.436-.716-2.517-.622-2.26-1.524-5.541-2.691-9.782l-.005-.018v-.02c-.22-5.929-.511-13.745-.861-23.17l-.011-.276.277,0a2.541,2.541,0,0,1,1.426.379,1.71,1.71,0,0,1,.743,1.436l-.01-.086q.954,3.434,1.981,7.138l-.511-.1,5.494-7.23.02-.026.017-.015a3.247,3.247,0,0,1,1.428-.785,1.077,1.077,0,0,1,.956.26,1.8,1.8,0,0,1,.426.787,3.293,3.293,0,0,1,.069,1.632c-.046.258-.1.5-.125.72-.015.126,0,.173-.009.343a1.767,1.767,0,0,1-.091.467,49.319,49.319,0,0,1-2.692,5.652l.039-.144c-.049,1.875-.048,3.791.057,5.716a19.991,19.991,0,0,0,.325,2.863,2.195,2.195,0,0,0,.492,1.135,3.055,3.055,0,0,0,.546.383.727.727,0,0,0,.224.079h.017a.344.344,0,0,0,.022.071l.012.019.007,0,.023.012.041.018.01,0c.165.062-.211-.08-.174-.062l-.006.017-.011.123q-.333-3.66-.675-7.431l-.015-.165.119-.114c2.33-2.231,4.7-4.484,7.286-6.609q.486-.4,1.005-.771c.182-.12.343-.249.544-.362a1.863,1.863,0,0,1,.739-.3,1.107,1.107,0,0,1,.837.259.921.921,0,0,1,.175.933c-.139.471-.317.817-.456,1.21-.776,1.608-1.666,2.981-2.537,4.465-.77,1.257-1.535,2.509-2.246,3.671l.042-.273c.6,2.328,1.185,4.635,1.735,6.784l-.642-.089c1.224-2.074,2.474-4.1,3.813-6.037a27.257,27.257,0,0,1,2.157-2.8,5.274,5.274,0,0,1,.662-.636,2.315,2.315,0,0,1,.872-.446,8.511,8.511,0,0,1,.869-.231,1.6,1.6,0,0,1,.543-.024.792.792,0,0,1,.58.412,2.744,2.744,0,0,1,.215.96,3.051,3.051,0,0,1-.042.521l-.111.437c-.164.563-.361,1.1-.561,1.625-.4,1.055-.843,2.08-1.28,3.094-.882,2.024-1.785,3.989-2.691,5.9l.029-.185c.465,3.626.877,7.155,1.041,10.591a11.555,11.555,0,0,1-.614,5.07,10.152,10.152,0,0,1-2.859,3.994l.113-.242c.476,14.579.868,26.626,1.144,35.068.116,4.174.208,7.456.272,9.734.02,1.092.037,1.942.049,2.555C326.117,328.019,326.1,328.318,326.1,328.318Z",
    fill: "#7c3b29"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7103",
    "data-name": "Group 7103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7102",
    "data-name": "Group 7102"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7101",
    "data-name": "Group 7101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7100",
    "data-name": "Group 7100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5427",
    "data-name": "Path 5427",
    d: "M310.125,257.591c-.194.021-.575-2.816-.852-6.335s-.344-6.381-.15-6.391.575,2.827.852,6.336S310.318,257.57,310.125,257.591Z",
    fill: "#7c3b29"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Character_1",
    "data-name": "Character 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7112",
    "data-name": "Group 7112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7111",
    "data-name": "Group 7111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7107",
    "data-name": "Group 7107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7106",
    "data-name": "Group 7106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5428",
    "data-name": "Path 5428",
    d: "M273.006,265.806l-15.667-31.673a116.4,116.4,0,1,0-23.962,34.128l-.033.057Z",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7110",
    "data-name": "Group 7110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7109",
    "data-name": "Group 7109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7108",
    "data-name": "Group 7108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5429",
    "data-name": "Path 5429",
    d: "M273.006,265.806l-39.655,2.625-.215.015.11-.187.033-.056.178.139a120.848,120.848,0,0,1-9.122,8.113c-1.66,1.4-3.492,2.675-5.328,4.053-1.9,1.293-3.823,2.66-5.9,3.91a114.969,114.969,0,0,1-29.081,12.968,117.364,117.364,0,0,1-36.9,4.5,115.693,115.693,0,0,1-40.885-9.172,117.239,117.239,0,0,1-38-26.03A116.387,116.387,0,0,1,36.09,172.239c.189-2.263.628-4.5.962-6.755.376-2.249.9-4.479,1.365-6.724a117.961,117.961,0,0,1,25.494-49.611l2.408-2.653,1.205-1.322,1.263-1.264,2.519-2.523,2.626-2.4A114.146,114.146,0,0,1,96.886,82.872c2.016-1.147,4.129-2.086,6.2-3.092,2.08-.987,4.229-1.807,6.332-2.708,2.161-.754,4.281-1.607,6.456-2.273,2.18-.646,4.326-1.386,6.532-1.887a119.416,119.416,0,0,1,26.41-3.73,116.412,116.412,0,0,1,110.731,72.45,120.939,120.939,0,0,1,5.8,18.566q.457,2.307.9,4.574c.317,1.507.469,3.029.708,4.521q.164,1.122.325,2.233.115,1.116.231,2.222c.17,1.473.281,2.937.365,4.388a115.953,115.953,0,0,1-5.979,44.9c-1.4,4.047-2.928,7.755-4.469,11.142v-.094l15.57,31.721-15.764-31.625-.023-.045.021-.048c1.528-3.385,3.042-7.09,4.43-11.131a115.966,115.966,0,0,0,5.876-44.8c-.087-1.447-.2-2.906-.371-4.374q-.115-1.1-.234-2.216-.164-1.108-.327-2.226c-.241-1.487-.394-3-.712-4.506q-.45-2.259-.909-4.558a120.7,120.7,0,0,0-5.808-18.5,114.738,114.738,0,0,0-22.856-35.565,115.953,115.953,0,0,0-87.5-36.535,118.988,118.988,0,0,0-26.3,3.724c-2.195.5-4.332,1.237-6.5,1.88-2.164.664-4.275,1.514-6.426,2.265-2.094.9-4.232,1.715-6.3,2.7-2.062,1-4.166,1.938-6.172,3.081A113.6,113.6,0,0,0,74.28,99.374l-2.614,2.388-2.509,2.513L67.9,105.533l-1.2,1.316-2.4,2.642a117.282,117.282,0,0,0-25.383,49.388c-.463,2.235-.986,4.455-1.36,6.694-.332,2.246-.771,4.472-.959,6.724a116,116,0,0,0,147.33,124.755,114.852,114.852,0,0,0,29.023-12.88c2.073-1.244,4-2.6,5.892-3.888,1.835-1.371,3.666-2.644,5.326-4.032a121.734,121.734,0,0,0,9.124-8.072l.6-.573-.422.712-.033.057-.1-.172Z",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7114",
    "data-name": "Group 7114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7113",
    "data-name": "Group 7113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5430",
    "data-name": "Path 5430",
    d: "M92.01,285.545l119.759-.2s-28.631,18.973-63.019,16.734C118.868,300.138,92.01,285.545,92.01,285.545Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7326",
    "data-name": "Group 7326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7120",
    "data-name": "Group 7120"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7116",
    "data-name": "Group 7116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7115",
    "data-name": "Group 7115"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5431",
    "data-name": "Path 5431",
    d: "M144.446,205.2l6.831,24.986,24.95-33.69-5.874,88.34H134.732l-10.386.5s1.54-13.924,2.173-21.785a87.914,87.914,0,0,1,3.165-18.509C135,227.7,144.446,205.2,144.446,205.2Z",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7119",
    "data-name": "Group 7119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7118",
    "data-name": "Group 7118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7117",
    "data-name": "Group 7117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5432",
    "data-name": "Path 5432",
    d: "M152.489,244.3c.088.114-3.936,3.357-8.986,7.243s-9.216,6.945-9.3,6.831,3.935-3.356,8.987-7.244S152.4,244.183,152.489,244.3Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7140",
    "data-name": "Group 7140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7122",
    "data-name": "Group 7122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7121",
    "data-name": "Group 7121"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5433",
    "data-name": "Path 5433",
    d: "M214.5,193.023l-19.4-9.334-7.608-9.043-10.764,11.189L148.191,284.6h48.936l6.275-16.944,11.1-65.442Z",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7124",
    "data-name": "Group 7124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7123",
    "data-name": "Group 7123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5434",
    "data-name": "Path 5434",
    d: "M127.2,286.029l-1.311-20.961L185,255.053s10.1-48.784,16.321-56.777c5.742-7.377,13.229-4.818,13.229-4.818s6.745,4.621,5.133,22.314c-.845,9.264-4.232,41.388-5.461,52.994a18.5,18.5,0,0,1-2.692,7.831h0a18.524,18.524,0,0,1-15.732,8.742Z",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7127",
    "data-name": "Group 7127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7126",
    "data-name": "Group 7126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7125",
    "data-name": "Group 7125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5435",
    "data-name": "Path 5435",
    d: "M194.656,267.231c-.086.009-.169-.931-.6-2.365a14.023,14.023,0,0,0-7.29-8.645c-1.341-.666-2.253-.906-2.23-.99a6.326,6.326,0,0,1,2.384.656,12.935,12.935,0,0,1,7.491,8.883A6.293,6.293,0,0,1,194.656,267.231Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7130",
    "data-name": "Group 7130",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7129",
    "data-name": "Group 7129"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7128",
    "data-name": "Group 7128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5436",
    "data-name": "Path 5436",
    d: "M193.578,185.113a92.454,92.454,0,0,1-3.524,18.211l-4.446-1.305a11.574,11.574,0,0,1,1.327,9.189,34.333,34.333,0,0,1-3.842,8.723l-22.065,39.634,22.243-50.5-.579-9.335,4.282-.915Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7133",
    "data-name": "Group 7133",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7132",
    "data-name": "Group 7132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7131",
    "data-name": "Group 7131"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5437",
    "data-name": "Path 5437",
    d: "M184.809,254.468a11.795,11.795,0,0,1,12.091,8.751,3.041,3.041,0,0,1,.035,1.9,1.26,1.26,0,0,1-1.543.79,2,2,0,0,1-.866-1.146,17.929,17.929,0,0,0-10.277-9.575"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7136",
    "data-name": "Group 7136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7135",
    "data-name": "Group 7135"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7134",
    "data-name": "Group 7134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5438",
    "data-name": "Path 5438",
    d: "M161.192,259.087a5.224,5.224,0,0,1,.3-.811l.954-2.282,3.6-8.357c3.1-7.076,7.354-16.776,12.052-27.491,1.722-3.893,3.385-7.652,4.947-11.18l-.021.116c-.2-3.317-.383-6.447-.554-9.337l-.011-.193.188-.04,4.286-.9-.142.111c2.219-4.488,4.04-8.173,5.331-10.785.63-1.244,1.13-2.231,1.494-2.951l.4-.765a1.127,1.127,0,0,1,.156-.252,1.053,1.053,0,0,1-.1.279l-.35.791-1.394,3c-1.252,2.63-3.019,6.342-5.17,10.863l-.043.089-.1.022-4.278.933.176-.232c.187,2.889.39,6.017.605,9.333l0,.06-.025.056-4.927,11.189c-4.752,10.692-9.053,20.37-12.191,27.429-1.567,3.467-2.843,6.287-3.749,8.29l-1.044,2.244A5.532,5.532,0,0,1,161.192,259.087Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7139",
    "data-name": "Group 7139"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7138",
    "data-name": "Group 7138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7137",
    "data-name": "Group 7137"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5439",
    "data-name": "Path 5439",
    d: "M127.153,285.339a1.784,1.784,0,0,1-.048-.348c-.022-.259-.052-.6-.089-1.025-.068-.935-.164-2.256-.288-3.941-.228-3.459-.555-8.4-.958-14.5l-.011-.167.165-.031,42.765-7.855,15.768-2.861-.2.184c3.467-13.17,6.475-24.6,8.627-32.773,1.084-4.041,1.952-7.276,2.559-9.536q.451-1.629.706-2.548c.079-.268.143-.483.193-.655a.865.865,0,0,1,.081-.219.985.985,0,0,1-.037.23l-.151.667c-.15.616-.359,1.474-.625,2.568-.573,2.269-1.392,5.517-2.416,9.574-2.108,8.185-5.054,19.631-8.449,32.819l-.04.155-.158.029-15.765,2.878L125.993,265.7l.154-.2c.332,6.1.6,11.047.79,14.508.08,1.688.143,3.011.188,3.948.014.428.026.768.035,1.028A1.6,1.6,0,0,1,127.153,285.339Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7143",
    "data-name": "Group 7143"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7142",
    "data-name": "Group 7142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7141",
    "data-name": "Group 7141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5440",
    "data-name": "Path 5440",
    d: "M211.519,191.385c.015.094-.989.243-2.5.805a16,16,0,0,0-8.928,8.363c-.659,1.47-.873,2.463-.966,2.441a1.905,1.905,0,0,1,.076-.712,10.135,10.135,0,0,1,.551-1.872,14.727,14.727,0,0,1,9.147-8.568,10.065,10.065,0,0,1,1.9-.427A1.937,1.937,0,0,1,211.519,191.385Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7157",
    "data-name": "Group 7157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7148",
    "data-name": "Group 7148"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7147",
    "data-name": "Group 7147"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7146",
    "data-name": "Group 7146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7145",
    "data-name": "Group 7145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7144",
    "data-name": "Group 7144"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5441",
    "data-name": "Path 5441",
    d: "M99.756,169.162c1.752-3.229.976-16.27,3.677-15.808,3.442.588.262,14.294.045,15.543-.21,1.212,1.589,1.557,1.723.421.2-1.633,2.2-17.581,5.593-16.683,1.879.5,1.015,3.928,1.015,3.928s-2.915,15.458-1.3,15.828c1.641.377,2.851-8.544,3.573-11.786.691-3.109,2.714-4.446,3.483-2.807,1.127,2.4-1.035,10.188-1.679,13.312s-2.255,12.166,2.129,8.633,9.058-4.641,10.511-4.076,1.137,2.8-.548,3.242a21.041,21.041,0,0,0-5,2.682,20.078,20.078,0,0,0-3.316,3.117,17.522,17.522,0,0,0-3.137,4.883,10.914,10.914,0,0,1-6.665,5.966h0l-2.56,12.181-16.58-3.552,3.7-12.889c1.345-8.463.6-19.844.613-25.021.018-8.254,1.094-8.315,2.044-8.1C99.171,158.661,98.047,172.313,99.756,169.162Z",
    fill: "#ffd1bd"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7152",
    "data-name": "Group 7152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7151",
    "data-name": "Group 7151"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7150",
    "data-name": "Group 7150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7149",
    "data-name": "Group 7149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5442",
    "data-name": "Path 5442",
    d: "M99.291,180.242a18.18,18.18,0,0,1,2.205,1.027,9.106,9.106,0,0,1,4.24,6.163l.055.282.235-.139a13.735,13.735,0,0,1,4.295-1.623c1.133-.222,1.832-.244,1.83-.3a5.51,5.51,0,0,0-1.872.045,12.345,12.345,0,0,0-4.447,1.528l.29.144a9.226,9.226,0,0,0-.514-1.833,9.34,9.34,0,0,0-1.822-2.846,8.843,8.843,0,0,0-2.152-1.673,7.514,7.514,0,0,0-1.686-.678A1.988,1.988,0,0,0,99.291,180.242Z",
    fill: "#cc8f75"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7156",
    "data-name": "Group 7156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7155",
    "data-name": "Group 7155"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7154",
    "data-name": "Group 7154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7153",
    "data-name": "Group 7153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5443",
    "data-name": "Path 5443",
    d: "M97.086,191.838a14.589,14.589,0,0,0,8.115,2.528c.013-.12-1.891-.339-4.127-1.043S97.144,191.731,97.086,191.838Z",
    fill: "#cc8f75"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7159",
    "data-name": "Group 7159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7158",
    "data-name": "Group 7158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5444",
    "data-name": "Path 5444",
    d: "M157.113,179.841,144.446,205.2l6.831,24.986,18.188-19.221L187.4,177.661Z",
    fill: "#ffd1bd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7180",
    "data-name": "Group 7180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7161",
    "data-name": "Group 7161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7160",
    "data-name": "Group 7160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5445",
    "data-name": "Path 5445",
    d: "M145.187,182.22s-18,6.4-18,7.591v.007c-3.179,2.5-13.77,28.1-17.139,32.938l-9.631,14.19h0l8.078-31.53-17.773-5.228S75.541,236.863,73.7,245.021a29.982,29.982,0,0,0,.287,14.63l.1-.084a16.886,16.886,0,0,0,6.658,8.954c7.535,4.832,14.57,5.741,21.769.422,4.082-3.016,8.741-6.65,13.01-10.05l1.118,26.475h9.815c0-1.487-.3-19.629-.3-19.629a102.412,102.412,0,0,0,2.974-13.086c.893-6.245,15.514-47.226,15.514-47.226l11.351-21.857.264-8.088Z",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7164",
    "data-name": "Group 7164"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7163",
    "data-name": "Group 7163"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7162",
    "data-name": "Group 7162"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5446",
    "data-name": "Path 5446",
    d: "M116.442,285.144a5.169,5.169,0,0,1-.085-.825q-.054-.877-.147-2.374c-.109-2.113-.262-5.1-.452-8.78-.337-7.481-.8-17.8-1.322-29.352l0-.03.007-.034c.211-1.094.437-2.26.664-3.438,2.38-12.145,4.533-23.136,6.1-31.147l1.907-9.426q.344-1.614.545-2.557l.154-.663a.776.776,0,0,1,.07-.222.762.762,0,0,1-.018.233l-.1.673q-.165.95-.448,2.577c-.421,2.281-1.015,5.5-1.746,9.46-1.531,8.019-3.632,19.021-5.953,31.178-.228,1.178-.454,2.344-.666,3.438l.005-.064c.456,11.558.863,21.876,1.158,29.359.122,3.687.221,6.672.291,8.787q.035,1.5.054,2.378A5.165,5.165,0,0,1,116.442,285.144Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7167",
    "data-name": "Group 7167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7166",
    "data-name": "Group 7166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7165",
    "data-name": "Group 7165"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5447",
    "data-name": "Path 5447",
    d: "M126.506,261.644a5.137,5.137,0,0,1,.09-.83q.133-.881.359-2.364c.342-2.1.823-5.051,1.414-8.675,1.251-7.362,2.965-17.448,4.859-28.59l3.481-19.959,0-.028.011-.024c2.495-5.659,4.583-10.393,6.069-13.765.732-1.621,1.315-2.912,1.736-3.846l.474-1.007a1.6,1.6,0,0,1,.184-.336,1.522,1.522,0,0,1-.119.364c-.107.271-.243.612-.411,1.034l-1.62,3.9-5.9,13.84.015-.051-3.413,19.97c-1.952,11.132-3.719,21.209-5.009,28.564-.659,3.613-1.2,6.555-1.577,8.648q-.287,1.473-.455,2.347A4.983,4.983,0,0,1,126.506,261.644Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7170",
    "data-name": "Group 7170"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7169",
    "data-name": "Group 7169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7168",
    "data-name": "Group 7168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5448",
    "data-name": "Path 5448",
    d: "M92.01,258.7c-.069-.05.7-1.153,1.781-3.031a55.171,55.171,0,0,0,3.611-7.636,64.57,64.57,0,0,0,2.478-8.084c.5-2.109.731-3.434.813-3.422a3.327,3.327,0,0,1-.05.949c-.062.607-.2,1.48-.4,2.551a49.66,49.66,0,0,1-2.352,8.193,43.866,43.866,0,0,1-3.782,7.639,25.621,25.621,0,0,1-1.47,2.126C92.26,258.47,92.039,258.726,92.01,258.7Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7173",
    "data-name": "Group 7173",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7172",
    "data-name": "Group 7172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7171",
    "data-name": "Group 7171"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5449",
    "data-name": "Path 5449",
    d: "M93.367,257.24a1.1,1.1,0,0,0-.76,1.546,1.647,1.647,0,0,0,1.72.788,3.419,3.419,0,0,0,1.749-.955,11.972,11.972,0,0,0,3.059-5.339c1.521-4.818,1.594-9.956,1.654-15.008a61.5,61.5,0,0,1-7.377,18.682"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7176",
    "data-name": "Group 7176",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7175",
    "data-name": "Group 7175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7174",
    "data-name": "Group 7174"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5450",
    "data-name": "Path 5450",
    d: "M115.234,259.593a26.564,26.564,0,0,1-3.63-16.206c.538-7.695,4.279-14.733,7.071-21.924-1.608,7.562-2.523,15.068-3.98,22.339,0,0,.778,10.8.8,15.6"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7179",
    "data-name": "Group 7179",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7178",
    "data-name": "Group 7178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7177",
    "data-name": "Group 7177"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5451",
    "data-name": "Path 5451",
    d: "M127.651,254.77c.781-11.517,1.566-23.061,3.6-34.423a109.856,109.856,0,0,1,11.6-33.229c-1.45,4.563-5.919,14.146-5.919,14.146s-6.456,34.019-9.253,51.154"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7213",
    "data-name": "Group 7213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7183",
    "data-name": "Group 7183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7182",
    "data-name": "Group 7182"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7181",
    "data-name": "Group 7181"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5452",
    "data-name": "Path 5452",
    d: "M126.2,268.011l1.613,17.859-8.434-.033c-.223,0-3.666-.056-7.462-.121a52.358,52.358,0,0,1-8.561.229c-.238-.025-.379-.055-.4-.09a6.767,6.767,0,0,1-1.3-.314h-.038l0-.012c-.763-.279-1.548-.771-1.426-1.61.369-2.56,1.891-2.766,1.891-2.766s.288-.021.764-.053l.062-.223c-1.159,0-2.132-.029-2.648-.083-.238-.025-.379-.055-.4-.089,0,0-2.99-.355-2.761-1.937C97.478,276.208,99,276,99,276s1.034-.074,2.461-.166c-1.195,0-2.207-.026-2.736-.082-.238-.025-.379-.055-.4-.089,0,0-2.989-.355-2.761-1.937.37-2.561,1.892-2.766,1.892-2.766s.833-.059,2.036-.138c-.968-.005-1.768-.035-2.219-.083-.238-.025-.379-.055-.4-.089,0,0-2.989-.355-2.761-1.936.369-2.561,1.892-2.767,1.892-2.767s4.7-.335,7.934-.469c0,0,3.665-3.3,5.108-3.152,2.156.228,14.7,4.858,14.7,4.858Z",
    fill: "#ffd1bd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7208",
    "data-name": "Group 7208"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7207",
    "data-name": "Group 7207"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7206",
    "data-name": "Group 7206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7205",
    "data-name": "Group 7205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7190",
    "data-name": "Group 7190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7189",
    "data-name": "Group 7189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7188",
    "data-name": "Group 7188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7187",
    "data-name": "Group 7187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7186",
    "data-name": "Group 7186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7185",
    "data-name": "Group 7185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7184",
    "data-name": "Group 7184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5453",
    "data-name": "Path 5453",
    d: "M110.375,280.628a16.877,16.877,0,0,1-4.179.4,16.068,16.068,0,0,1-4.137-.133,16.894,16.894,0,0,1,4.181-.4A15.948,15.948,0,0,1,110.375,280.628Z",
    fill: "#cc8f75"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7197",
    "data-name": "Group 7197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7196",
    "data-name": "Group 7196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7195",
    "data-name": "Group 7195"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7194",
    "data-name": "Group 7194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7193",
    "data-name": "Group 7193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7192",
    "data-name": "Group 7192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7191",
    "data-name": "Group 7191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5454",
    "data-name": "Path 5454",
    d: "M110.4,275.564a33.03,33.03,0,0,1-5.943.481,33.212,33.212,0,0,1-5.963-.058,32.99,32.99,0,0,1,5.944-.482A33.138,33.138,0,0,1,110.4,275.564Z",
    fill: "#cc8f75"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7204",
    "data-name": "Group 7204",
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7203",
    "data-name": "Group 7203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7202",
    "data-name": "Group 7202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7201",
    "data-name": "Group 7201"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7200",
    "data-name": "Group 7200"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7199",
    "data-name": "Group 7199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7198",
    "data-name": "Group 7198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5455",
    "data-name": "Path 5455",
    d: "M109.977,270.42a33.142,33.142,0,0,1-5.943.481,33.041,33.041,0,0,1-5.963-.059,33.032,33.032,0,0,1,5.944-.481A33.022,33.022,0,0,1,109.977,270.42Z",
    fill: "#cc8f75"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7212",
    "data-name": "Group 7212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7211",
    "data-name": "Group 7211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7210",
    "data-name": "Group 7210"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7209",
    "data-name": "Group 7209"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5456",
    "data-name": "Path 5456",
    d: "M102.6,265.583a8.629,8.629,0,0,0,1.895.149l4.568.149,4.568.164a8.547,8.547,0,0,0,1.9-.019,7.836,7.836,0,0,0-1.881-.291c-1.167-.117-2.784-.232-4.573-.293s-3.409-.058-4.582-.021A7.788,7.788,0,0,0,102.6,265.583Z",
    fill: "#cc8f75"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7325",
    "data-name": "Group 7325"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7215",
    "data-name": "Group 7215"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7214",
    "data-name": "Group 7214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5457",
    "data-name": "Path 5457",
    d: "M195.677,120.109c2.119-5.154,8.827-7.5,14.059-5.583s8.726,7.287,9.355,12.823a11.524,11.524,0,0,1-1.6,7.879,10.638,10.638,0,0,1-7.325,4.119,14.593,14.593,0,0,1-15.428-20.232",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7218",
    "data-name": "Group 7218"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7217",
    "data-name": "Group 7217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7216",
    "data-name": "Group 7216"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5458",
    "data-name": "Path 5458",
    d: "M216.969,120.793c.028.019-.1.267-.376.683a12.383,12.383,0,0,1-1.345,1.642,14.928,14.928,0,0,1-12.838,4.407,12.292,12.292,0,0,1-2.07-.469,2.084,2.084,0,0,1-.717-.308c.025-.086,1.079.249,2.829.412a15.946,15.946,0,0,0,12.538-4.305C216.271,121.652,216.9,120.74,216.969,120.793Z",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7221",
    "data-name": "Group 7221"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7220",
    "data-name": "Group 7220"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7219",
    "data-name": "Group 7219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5459",
    "data-name": "Path 5459",
    d: "M219.194,126.671c.022.029-.182.22-.573.542a18.3,18.3,0,0,1-1.737,1.253,19.774,19.774,0,0,1-6.521,2.739,16.2,16.2,0,0,1-3.91.31,14.445,14.445,0,0,1-3.156-.522,12,12,0,0,1-2.013-.751c-.456-.223-.7-.36-.684-.393.039-.091,1.056.38,2.788.788a16.194,16.194,0,0,0,3.085.4,17.218,17.218,0,0,0,3.784-.34,22.41,22.41,0,0,0,6.435-2.543C218.239,127.256,219.142,126.6,219.194,126.671Z",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7223",
    "data-name": "Group 7223"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7222",
    "data-name": "Group 7222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5460",
    "data-name": "Path 5460",
    d: "M141.6,135.5c-12.378-27.226,17.067-40.9,33.134-36.367,15.1,4.265,21.54,11.78,24.024,21.879s2.367,21.046-1.592,30.668c-1.953,4.745-5.469,9.565-10.565,10.158",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7225",
    "data-name": "Group 7225"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7224",
    "data-name": "Group 7224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5461",
    "data-name": "Path 5461",
    d: "M156.387,202.79c-.213-13.009-.364-30.877-.369-30.8,0,0-11.182-1.857-13.5-16.446-1.153-7.255-.788-19.15-.176-28.874.552-8.752,6.351-19.491,15.072-18.568l27.231,6.883a5.13,5.13,0,0,1,4.59,5.2h0l-1.774,56.325",
    fill: "#ffd1bd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7232",
    "data-name": "Group 7232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7231",
    "data-name": "Group 7231"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7230",
    "data-name": "Group 7230"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7229",
    "data-name": "Group 7229"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7228",
    "data-name": "Group 7228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7227",
    "data-name": "Group 7227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7226",
    "data-name": "Group 7226"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5462",
    "data-name": "Path 5462",
    d: "M149.023,137.034a1.86,1.86,0,0,0,1.771,1.9,1.778,1.778,0,0,0,1.937-1.654,1.861,1.861,0,0,0-1.769-1.9A1.781,1.781,0,0,0,149.023,137.034Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7239",
    "data-name": "Group 7239"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7238",
    "data-name": "Group 7238"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7237",
    "data-name": "Group 7237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7236",
    "data-name": "Group 7236"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7235",
    "data-name": "Group 7235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7234",
    "data-name": "Group 7234"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7233",
    "data-name": "Group 7233"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5463",
    "data-name": "Path 5463",
    d: "M169.2,137.034a1.86,1.86,0,0,0,1.771,1.9,1.78,1.78,0,0,0,1.937-1.654,1.86,1.86,0,0,0-1.769-1.9A1.779,1.779,0,0,0,169.2,137.034Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7242",
    "data-name": "Group 7242"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7241",
    "data-name": "Group 7241"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7240",
    "data-name": "Group 7240"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5464",
    "data-name": "Path 5464",
    d: "M157.125,147.362a13.384,13.384,0,0,0-3.27-.59c-.514-.053-1-.155-1.087-.505a2.619,2.619,0,0,1,.343-1.524q.726-1.866,1.521-3.915c2.111-5.574,3.639-10.157,3.414-10.24s-2.12,4.367-4.231,9.941q-.762,2.063-1.456,3.938a2.976,2.976,0,0,0-.267,2.018,1.293,1.293,0,0,0,.846.752,3.493,3.493,0,0,0,.873.121A13.03,13.03,0,0,0,157.125,147.362Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7244",
    "data-name": "Group 7244"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7243",
    "data-name": "Group 7243"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5465",
    "data-name": "Path 5465",
    d: "M155.992,172.046a37.11,37.11,0,0,0,19.538-5.212s-4.937,10.15-19.538,8.785Z",
    fill: "#cc8f75"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7251",
    "data-name": "Group 7251"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7250",
    "data-name": "Group 7250"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7249",
    "data-name": "Group 7249"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7248",
    "data-name": "Group 7248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7247",
    "data-name": "Group 7247"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7246",
    "data-name": "Group 7246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7245",
    "data-name": "Group 7245"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5466",
    "data-name": "Path 5466",
    d: "M186.452,138.592c.214-.1,7.809-3.462,7.9,5.272s-8.7,7.022-8.716,6.772S186.452,138.592,186.452,138.592Z",
    fill: "#ffd1bd"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7259",
    "data-name": "Group 7259"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7258",
    "data-name": "Group 7258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7257",
    "data-name": "Group 7257"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7256",
    "data-name": "Group 7256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7255",
    "data-name": "Group 7255"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7254",
    "data-name": "Group 7254"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7253",
    "data-name": "Group 7253"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7252",
    "data-name": "Group 7252"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5467",
    "data-name": "Path 5467",
    d: "M188.269,147.3c.038-.029.153.1.411.22a1.524,1.524,0,0,0,1.138.012c.919-.348,1.681-1.821,1.707-3.4a5.028,5.028,0,0,0-.448-2.174,1.758,1.758,0,0,0-1.156-1.156.773.773,0,0,0-.894.426c-.115.245-.057.419-.1.434-.025.023-.189-.144-.123-.505a.977.977,0,0,1,.338-.551,1.148,1.148,0,0,1,.84-.231,2.139,2.139,0,0,1,1.6,1.338,5.159,5.159,0,0,1,.552,2.429c-.038,1.761-.922,3.417-2.181,3.795a1.629,1.629,0,0,1-1.394-.218C188.286,147.511,188.238,147.316,188.269,147.3Z",
    fill: "#cc8f75"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7269",
    "data-name": "Group 7269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7263",
    "data-name": "Group 7263"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7262",
    "data-name": "Group 7262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7261",
    "data-name": "Group 7261"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7260",
    "data-name": "Group 7260"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5468",
    "data-name": "Path 5468",
    d: "M157.72,152.972A8.421,8.421,0,0,0,158.8,155.1a2.827,2.827,0,0,0,2.009,1.166,2.537,2.537,0,0,0,2.144-1.169,4.047,4.047,0,0,0,.6-2.439c-.034-.769-.386-1.686-1.151-1.777a1.915,1.915,0,0,0-.928.206l-4.016,1.629",
    fill: "#cc8f75"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7268",
    "data-name": "Group 7268"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7267",
    "data-name": "Group 7267"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7266",
    "data-name": "Group 7266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7265",
    "data-name": "Group 7265"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7264",
    "data-name": "Group 7264"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5469",
    "data-name": "Path 5469",
    d: "M159.325,156.295a5.815,5.815,0,0,0,2.142-.265,3.063,3.063,0,0,0,1.619-1.471,3.225,3.225,0,0,0,.053-2.628,2.879,2.879,0,0,0-.35-.6c-.159-.167-.13-.16-.3-.134-.163.044-.427.168-.643.252l-.66.269c-.859.348-1.638.652-2.3.9a7.307,7.307,0,0,1-2.187.659,7.314,7.314,0,0,1,1.987-1.125c.633-.305,1.39-.658,2.236-1.039l.65-.291a7.335,7.335,0,0,1,.734-.3.939.939,0,0,1,.595.017,1.1,1.1,0,0,1,.443.351,3.444,3.444,0,0,1,.452.761,3.768,3.768,0,0,1-.123,3.214,3.433,3.433,0,0,1-2.038,1.648,3.245,3.245,0,0,1-1.741.068C159.5,156.471,159.309,156.334,159.325,156.295Z",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7271",
    "data-name": "Group 7271"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7270",
    "data-name": "Group 7270"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5470",
    "data-name": "Path 5470",
    d: "M196.247,132.614c-.895-.063-8.109.871-7.54,14.28.53,12.525,9.317,9.767,12.121,5.052C203.484,147.478,205.018,133.229,196.247,132.614Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7274",
    "data-name": "Group 7274"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7273",
    "data-name": "Group 7273"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7272",
    "data-name": "Group 7272"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5471",
    "data-name": "Path 5471",
    d: "M200.707,134.2a1.663,1.663,0,0,1-.034-.353c-.011-.261-.025-.6-.042-1.021-.026-.926-.062-2.216-.107-3.819-.066-3.294-.158-7.869-.264-13.152l.162.159-3.719,0,.167-.171c.027,1,.055,2.051.085,3.12.124,5.032.24,9.719.338,13.641l0,.116-.112.026a6.771,6.771,0,0,0-3.831,2.466,9.048,9.048,0,0,0-1.53,3.235,13.432,13.432,0,0,0-.394,2.29c-.024.268-.037.473-.044.612a.883.883,0,0,1-.02.211.676.676,0,0,1-.023-.211c-.008-.14-.009-.347,0-.617a11.781,11.781,0,0,1,.321-2.325,9.011,9.011,0,0,1,1.505-3.333,6.968,6.968,0,0,1,3.948-2.6l-.108.141c-.113-3.922-.247-8.608-.392-13.64-.028-1.069-.056-2.122-.082-3.12l0-.172h.172l3.719.005h.16l0,.159c.058,5.284.108,9.859.144,13.153.005,1.6.01,2.895.012,3.821l-.01,1.022A1.764,1.764,0,0,1,200.707,134.2Z",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7276",
    "data-name": "Group 7276"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7275",
    "data-name": "Group 7275"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5472",
    "data-name": "Path 5472",
    d: "M196.245,115.85a28.773,28.773,0,0,0-12.762-13.186,53.417,53.417,0,0,0-10.769-3.993s5.245-1.245,13.732,2.531c3.856,1.716,7.741,3.95,10.31,7.3,1.632,2.127,3.669,6.284,3.666,7.349Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7279",
    "data-name": "Group 7279"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7278",
    "data-name": "Group 7278"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7277",
    "data-name": "Group 7277"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5473",
    "data-name": "Path 5473",
    d: "M195.287,155.691a.774.774,0,0,1-.253-.074,3.932,3.932,0,0,1-.67-.346,5.877,5.877,0,0,1-1.891-2.017,9.693,9.693,0,0,1-1.16-3.933,28.656,28.656,0,0,1-.006-5.011,30.51,30.51,0,0,1,.83-4.941,14.19,14.19,0,0,1,1.442-3.836,5.922,5.922,0,0,1,1.9-2.006,4.005,4.005,0,0,1,.674-.34.728.728,0,0,1,.254-.07c.012.029-.331.15-.855.519a6.16,6.16,0,0,0-1.77,2.017,14.7,14.7,0,0,0-1.346,3.791,32.281,32.281,0,0,0-.8,4.894,30.184,30.184,0,0,0-.02,4.953,9.75,9.75,0,0,0,1.058,3.845,6.117,6.117,0,0,0,1.757,2.026C194.957,155.539,195.3,155.66,195.287,155.691Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7287",
    "data-name": "Group 7287"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7281",
    "data-name": "Group 7281"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7280",
    "data-name": "Group 7280"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_375",
    "data-name": "Rectangle 375",
    d: "M1.7,0H8.738a1.7,1.7,0,0,1,1.7,1.7v.533a1.7,1.7,0,0,1-1.7,1.7H1.7A1.7,1.7,0,0,1,0,2.234V1.7A1.7,1.7,0,0,1,1.7,0Z",
    transform: "translate(157.797 155.342) rotate(-11.103)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7283",
    "data-name": "Group 7283"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7282",
    "data-name": "Group 7282"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5474",
    "data-name": "Path 5474",
    d: "M167.5,154.681l30.654-9.616a1.446,1.446,0,0,1,1.81.938h0a1.446,1.446,0,0,1-1,1.836l-31.346,8.469Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7286",
    "data-name": "Group 7286"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7285",
    "data-name": "Group 7285"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7284",
    "data-name": "Group 7284"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5475",
    "data-name": "Path 5475",
    d: "M190.154,150.454a6.668,6.668,0,0,1,1.015-.357l2.8-.854c1.176-.363,2.62-.746,4.147-1.247a2.776,2.776,0,0,0,1-.618,1.534,1.534,0,0,0,.432-1.066.928.928,0,0,0-.633-.878,2.363,2.363,0,0,0-1.282.039l-9.19,2.957-2.8.865a6.607,6.607,0,0,1-1.041.274,6.479,6.479,0,0,1,1-.4l2.766-.967c2.347-.8,5.565-1.9,9.183-3.057a2.656,2.656,0,0,1,1.475-.029,1.266,1.266,0,0,1,.852,1.186,1.856,1.856,0,0,1-.532,1.3,3.086,3.086,0,0,1-1.122.682c-1.585.5-3,.849-4.194,1.187l-2.832.751A6.636,6.636,0,0,1,190.154,150.454Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7290",
    "data-name": "Group 7290"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7289",
    "data-name": "Group 7289"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7288",
    "data-name": "Group 7288"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5476",
    "data-name": "Path 5476",
    d: "M174.068,132.75c-.235.369-2.335-.775-4.94-.3-2.611.433-4.2,2.216-4.549,1.947-.167-.115.006-.762.7-1.551a6.384,6.384,0,0,1,7.6-1.316C173.8,132.034,174.186,132.585,174.068,132.75Z",
    fill: "#cc8f75"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7293",
    "data-name": "Group 7293"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7292",
    "data-name": "Group 7292"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7291",
    "data-name": "Group 7291"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5477",
    "data-name": "Path 5477",
    d: "M173.771,133.077a10.505,10.505,0,0,1-1.435-.361,7.7,7.7,0,0,0-6.567,1.476c-.709.554-1.077.992-1.142.941-.05-.034.218-.562.9-1.219a6.932,6.932,0,0,1,6.9-1.553C173.333,132.662,173.8,133.024,173.771,133.077Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7296",
    "data-name": "Group 7296"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7295",
    "data-name": "Group 7295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7294",
    "data-name": "Group 7294"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5478",
    "data-name": "Path 5478",
    d: "M175.117,127.212c-.213.7-2.442.648-5.1.775-2.655.083-4.889.285-5.144-.4-.113-.334.344-.845,1.252-1.3a9.507,9.507,0,0,1,3.792-.9,9.363,9.363,0,0,1,3.854.611C174.718,126.39,175.208,126.872,175.117,127.212Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7299",
    "data-name": "Group 7299"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7298",
    "data-name": "Group 7298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7297",
    "data-name": "Group 7297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5479",
    "data-name": "Path 5479",
    d: "M153.131,134.288c-.2.113-.6-.261-1.226-.7a6.368,6.368,0,0,0-2.657-1.073c-2.26-.374-4.075.673-4.337.305-.12-.158.187-.674.987-1.176a5.427,5.427,0,0,1,3.59-.673,4.928,4.928,0,0,1,3.2,1.834C153.251,133.59,153.3,134.2,153.131,134.288Z",
    fill: "#cc8f75"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7302",
    "data-name": "Group 7302"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7301",
    "data-name": "Group 7301"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7300",
    "data-name": "Group 7300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5480",
    "data-name": "Path 5480",
    d: "M153.377,135.374c-.07.046-.406-.455-1.114-1.081a7.017,7.017,0,0,0-6.823-1.481c-.9.274-1.418.588-1.463.517-.036-.046.416-.481,1.34-.864a6.537,6.537,0,0,1,7.2,1.564C153.2,134.762,153.429,135.347,153.377,135.374Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7305",
    "data-name": "Group 7305"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7304",
    "data-name": "Group 7304"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7303",
    "data-name": "Group 7303"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5481",
    "data-name": "Path 5481",
    d: "M154.284,128.087c-.13.717-2.259.922-4.786.951-2.527.011-4.659-.161-4.8-.875-.145-.695,1.979-1.712,4.781-1.729S154.418,127.39,154.284,128.087Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7307",
    "data-name": "Group 7307"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7306",
    "data-name": "Group 7306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5482",
    "data-name": "Path 5482",
    d: "M177.831,107.4a28.983,28.983,0,0,0-3.995,7.526,9.783,9.783,0,0,0,.856,8.229c1.536,2.257,4.172,3.44,6.568,4.75s4.853,3.108,5.448,5.773c.186.834-.17,3.745.457,4.326.859.8,2.367.307,3.02-.667s1.075-4.175,1.091-5.347l.153-10.9c.043-3.078,0-6.269-1.331-9.043-1.865-3.88-5.732-5.122-11.371-4.847",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7309",
    "data-name": "Group 7309"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7308",
    "data-name": "Group 7308"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5483",
    "data-name": "Path 5483",
    d: "M142.016,129.279a20.569,20.569,0,0,1,4.139-10.186,15.089,15.089,0,0,1,9.33-5.588c3.679-.554,7.4.466,11.11.678s7.946-.7,9.886-3.875c.6-.99.891-2.376.118-3.241a3.277,3.277,0,0,0-1.091-.716,27.981,27.981,0,0,0-15.9-2.572,21.956,21.956,0,0,0-13.93,7.791,18.1,18.1,0,0,0-3.531,15.377",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7312",
    "data-name": "Group 7312"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7311",
    "data-name": "Group 7311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7310",
    "data-name": "Group 7310"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5484",
    "data-name": "Path 5484",
    d: "M139.792,123.8a1.859,1.859,0,0,1-.173-.475,8.49,8.49,0,0,1-.295-1.421,12.279,12.279,0,0,1,.5-5.3,14.089,14.089,0,0,1,4.384-6.544,18.26,18.26,0,0,1,8.8-3.957,24.868,24.868,0,0,1,9.659.435,34.213,34.213,0,0,1,4.048,1.221c1.246.457,2.36.962,3.424,1.247a14.643,14.643,0,0,0,5.186.462,3.79,3.79,0,0,0,1.692-.832,1.314,1.314,0,0,1-.336.381,3.1,3.1,0,0,1-1.312.649,13.884,13.884,0,0,1-5.323-.3c-1.109-.273-2.245-.767-3.477-1.2a35.166,35.166,0,0,0-4.009-1.16,24.908,24.908,0,0,0-9.465-.389,18.051,18.051,0,0,0-8.577,3.81,13.951,13.951,0,0,0-4.343,6.291,12.785,12.785,0,0,0-.649,5.164C139.636,123.121,139.844,123.788,139.792,123.8Z",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7315",
    "data-name": "Group 7315"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7314",
    "data-name": "Group 7314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7313",
    "data-name": "Group 7313"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5485",
    "data-name": "Path 5485",
    d: "M155.93,100.858a2.822,2.822,0,0,1,.918-.178,12.722,12.722,0,0,1,2.551,0,14.858,14.858,0,0,1,7.759,3.1c1.294,1.031,2.373,2.145,3.518,2.922a9.241,9.241,0,0,0,3.372,1.358,7.653,7.653,0,0,0,2.462.168c.58-.071.874-.226.9-.184a1.64,1.64,0,0,1-.86.384,6.807,6.807,0,0,1-2.565-.006,9.1,9.1,0,0,1-3.573-1.323c-1.212-.791-2.318-1.912-3.572-2.91a15.522,15.522,0,0,0-7.48-3.146C157.26,100.761,155.937,100.956,155.93,100.858Z",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7318",
    "data-name": "Group 7318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7317",
    "data-name": "Group 7317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7316",
    "data-name": "Group 7316"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5486",
    "data-name": "Path 5486",
    d: "M200.1,127.643c-.047.021-.2-.347-.625-.907a6.254,6.254,0,0,0-2.319-1.783,9.886,9.886,0,0,0-4.264-.855,33.039,33.039,0,0,0-5.39.746,19.816,19.816,0,0,1-5.524.418,15.186,15.186,0,0,1-4.4-1.063,13.757,13.757,0,0,1-2.685-1.443,3.665,3.665,0,0,1-.86-.711,28.661,28.661,0,0,0,3.677,1.811,15.881,15.881,0,0,0,4.31.927,20.368,20.368,0,0,0,5.392-.452,30.578,30.578,0,0,1,5.481-.713,9.865,9.865,0,0,1,4.429,1,5.975,5.975,0,0,1,2.322,2,4.1,4.1,0,0,1,.381.743C200.084,127.54,200.111,127.636,200.1,127.643Z",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7321",
    "data-name": "Group 7321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7320",
    "data-name": "Group 7320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7319",
    "data-name": "Group 7319"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5487",
    "data-name": "Path 5487",
    d: "M198.513,120.638c-.043.019-.194-.342-.623-.876a5.824,5.824,0,0,0-2.33-1.645,8.715,8.715,0,0,0-4.215-.448c-1.62.159-3.364.65-5.254,1a11.262,11.262,0,0,1-5.435-.085,8.861,8.861,0,0,1-3.779-2.342,8.168,8.168,0,0,1-1.663-2.488,5,5,0,0,1-.264-.768c-.047-.18-.063-.276-.046-.282a11.437,11.437,0,0,0,2.233,3.278,8.813,8.813,0,0,0,3.656,2.142,11.134,11.134,0,0,0,5.205.033c1.854-.345,3.625-.828,5.3-.968a8.778,8.778,0,0,1,4.4.587,5.589,5.589,0,0,1,2.349,1.862A2.345,2.345,0,0,1,198.513,120.638Z",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7324",
    "data-name": "Group 7324"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7323",
    "data-name": "Group 7323"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7322",
    "data-name": "Group 7322"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5488",
    "data-name": "Path 5488",
    d: "M161.032,220.65a1.4,1.4,0,0,1,.185-.156c.124-.1.317-.24.558-.44a24.857,24.857,0,0,0,2.034-1.849,35,35,0,0,0,2.87-3.331c1.052-1.368,2.175-3,3.4-4.82,2.461-3.646,5.341-8.081,8.4-13.2,1.53-2.557,3.106-5.284,4.7-8.163l1.2-2.187a13.642,13.642,0,0,1,1.368-2.176,4.784,4.784,0,0,1,2.122-1.539,2.571,2.571,0,0,1,1.35-.149,1.307,1.307,0,0,1,.642.353,1.5,1.5,0,0,1,.345.653l.014.047-.018.05a2.379,2.379,0,0,1-.472.824,1.338,1.338,0,0,1-.877.42,2.813,2.813,0,0,1-1.734-.6,2.932,2.932,0,0,1-1.113-3.411,2.6,2.6,0,0,1,1.273-1.45,2.885,2.885,0,0,1,1.895-.265,2.014,2.014,0,0,1,1.538,1.2,1.024,1.024,0,0,1-.223,1.06,1.88,1.88,0,0,1-.9.489,2.654,2.654,0,0,1-2.933-1.341,2.393,2.393,0,0,1-.172-1.716,2.89,2.89,0,0,1,.891-1.449,2.315,2.315,0,0,1,1.558-.606,1.844,1.844,0,0,1,1.475.777,1.217,1.217,0,0,1,.183.883,1.162,1.162,0,0,1-.487.754,1.794,1.794,0,0,1-1.627.2,2.012,2.012,0,0,1-1.094-1.21,4.386,4.386,0,0,1-.246-1.583,5.576,5.576,0,0,1,.789-3.011,2.289,2.289,0,0,1,1.251-.946,2,2,0,0,1,1.511.273,1.488,1.488,0,0,1,.759,1.352,1.371,1.371,0,0,1-1,1.163,1.608,1.608,0,0,1-1.468-.238,2.069,2.069,0,0,1-.74-1.285,2.975,2.975,0,0,1,.124-1.449,6.708,6.708,0,0,1,.495-1.319,2.529,2.529,0,0,1,.946-1.046,3.1,3.1,0,0,1,1.294-.437,1.308,1.308,0,0,1,.7.095,1.537,1.537,0,0,1,.529.469,1.79,1.79,0,0,1,.291.636,1,1,0,0,1-.085.729,1.157,1.157,0,0,1-1.238.482,2.109,2.109,0,0,1-1.14-.59,3.4,3.4,0,0,1-.981-2.254,3.607,3.607,0,0,1,.612-2.3,2.727,2.727,0,0,1,.85-.8,2.38,2.38,0,0,1,1.088-.3,1.651,1.651,0,0,1,1.064.316,1.19,1.19,0,0,1,.451,1.017,1.652,1.652,0,0,1-1.436,1.4,1.753,1.753,0,0,1-1.64-.925,2.959,2.959,0,0,1-.409-1.776,10.768,10.768,0,0,1,1.087-3.05l1.091-2.479,1.52-3.425c.173-.379.306-.674.4-.887s.148-.3.148-.3-.034.108-.117.312l-.372.9-1.462,3.45q-.481,1.125-1.064,2.49a10.8,10.8,0,0,0-1.047,3,2.762,2.762,0,0,0,.392,1.65,1.554,1.554,0,0,0,1.446.819,1.435,1.435,0,0,0,1.234-1.2.952.952,0,0,0-.367-.813,1.425,1.425,0,0,0-.917-.261,2.142,2.142,0,0,0-.976.277,2.492,2.492,0,0,0-.765.726,3.35,3.35,0,0,0-.555,2.131,3.131,3.131,0,0,0,.906,2.069,1.825,1.825,0,0,0,1,.515.887.887,0,0,0,.954-.344,1.043,1.043,0,0,0-.192-1.05,1.261,1.261,0,0,0-.427-.379,1.039,1.039,0,0,0-.556-.065,2.462,2.462,0,0,0-2,1.332,6.289,6.289,0,0,0-.467,1.257,2.635,2.635,0,0,0-.114,1.308,1.755,1.755,0,0,0,.626,1.093,1.31,1.31,0,0,0,1.194.186,1.046,1.046,0,0,0,.776-.888,1.171,1.171,0,0,0-.614-1.047,1.7,1.7,0,0,0-1.271-.231,1.983,1.983,0,0,0-1.063.817,5.272,5.272,0,0,0-.724,2.822,4.047,4.047,0,0,0,.226,1.458,1.686,1.686,0,0,0,.9,1.017,1.474,1.474,0,0,0,1.321-.163.842.842,0,0,0,.217-1.171,1.523,1.523,0,0,0-1.21-.623,1.986,1.986,0,0,0-1.329.524,2.222,2.222,0,0,0,1.919,3.91,1.556,1.556,0,0,0,.737-.393.662.662,0,0,0,.146-.705,1.693,1.693,0,0,0-1.29-.974,2.429,2.429,0,0,0-2.783,1.493,2.586,2.586,0,0,0,.985,3.014,2.516,2.516,0,0,0,1.522.543,1.3,1.3,0,0,0,1.064-1.016l0,.1a.968.968,0,0,0-.739-.764,2.281,2.281,0,0,0-1.177.136,4.465,4.465,0,0,0-1.981,1.435,13.474,13.474,0,0,0-1.337,2.122l-1.205,2.186c-1.6,2.879-3.186,5.6-4.726,8.159-3.077,5.112-5.98,9.538-8.467,13.17-1.242,1.816-2.38,3.439-3.449,4.8a33.553,33.553,0,0,1-2.92,3.311A17.574,17.574,0,0,1,161.032,220.65Z",
    fill: "#263238"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalktoca);
export default __webpack_public_path__ + "static/media/talktoca.3038ebbfa398177faace193c97a98fb2.svg";
export { ForwardRef as ReactComponent };